var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCityOfLondonLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "403.961px",
    height: "353px",
    viewBox: "0 0 403.961 353",
    enableBackground: "new 0 0 403.961 353",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.6767801,0,0,-6.6767801,137.01788,143.22711)",
    id: "g222"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 0,-9.363 0,10e-4 c -0.005,-0.406 -0.019,-2.353 0.089,-3.161 1.161,-8.645 9.639,-11.729 9.639,-11.729 0,0 8.478,3.084 9.638,11.729 0.109,0.808 0.095,2.755 0.089,3.161 l 0,-10e-4 0,9.363 L 0,0",
    id: "path224",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path705",
    d: "m 245.08,344.161 c 10.037,0.196 16.786,-2.896 20.158,-9.36 -0.186,1.896 -1.953,4.283 -2.88,6.24 -0.08,0 -0.158,0 -0.238,0 -0.865,1.613 -2.4,2.561 -3.602,3.84 -2.442,1.477 -5.303,2.537 -8.88,2.881 -31.04,0 -62.081,0 -93.12,0 -3.83,-0.41 -6.761,-1.721 -9.358,-3.361 0,-0.078 0,-0.158 0,-0.237 -1.573,-1.065 -2.529,-2.751 -3.842,-4.08 -0.677,-1.646 -1.597,-3.044 -2.158,-4.801 0.014,-0.146 0.034,-0.284 0.238,-0.239 3.314,6.523 10.313,9.366 20.4,9.12 27.763,-0.003 55.522,-0.003 83.282,-0.003 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path569",
    d: "m 278.921,149.04 c 3.178,1.794 5.878,6.822 9.84,6.72 1.359,-0.035 3.66,-2.05 5.28,-3.12 4.716,-3.115 10.781,-6.846 15.6,-8.88 -10.822,7.018 -21.631,14.049 -24.479,29.04 -1.406,0.674 -2.489,1.671 -4.079,2.16 -0.132,-0.349 0.278,-1.241 -0.24,-1.2 0,-0.96 0,-1.92 0,-2.88 -0.242,-3.46 2.868,-4.712 2.88,-7.44 0.016,-3.67 -6.343,-7.724 -7.92,-10.32 -0.616,-0.869 -1.995,-3.384 -3.12,-2.16 -1.431,2.17 -3.004,4.196 -6,4.8 -0.168,-0.334 1.659,-1.897 -0.24,-2.16 0.17,-2.27 1.561,-3.064 1.2,-5.04 -0.488,-2.689 -4.425,-3.493 -7.438,-3.84 -1.284,-0.399 -4.235,-0.399 -5.521,0 -2.271,0.128 -2.728,2.073 -3.359,3.84 -0.658,0.7 -2.544,0.176 -2.159,1.92 -1.389,-1.106 -1.749,-3.772 -0.96,-5.76 -0.181,-0.541 -1.348,-0.094 -1.921,-0.24 -0.839,0.681 -0.646,2.395 -0.961,3.6 -0.436,1.084 -2.504,0.536 -2.64,1.92 -0.851,-0.59 -0.671,-2.209 -1.2,-3.12 0,-0.8 0,-1.6 0,-2.4 -9.043,0.316 -19.354,-0.636 -27.6,0.48 -2.533,1.757 -6.357,1.649 -8.642,-0.24 -1.175,2.586 -2.846,4.675 -4.801,6.48 -1,0.121 -1.398,0.84 -2.398,0.96 -1.326,0.423 -3.69,0.301 -5.04,0 -0.16,0 -0.32,0 -0.48,0 -0.494,-0.466 -1.251,-0.668 -1.92,-0.96 -0.801,-0.719 -1.553,-1.487 -2.398,-2.16 -0.377,-1.382 -1.178,-2.343 -0.96,-4.32 -4.287,-0.423 -12.168,-0.24 -18.48,-0.24 -2.427,0 -7.66,-1.074 -6.24,2.16 -0.018,1.502 -0.629,2.412 -0.96,3.6 -0.123,-1.397 -1.917,-1.123 -2.64,-1.92 -0.404,-0.956 -0.357,-2.363 -0.72,-3.36 -0.019,-0.717 -2.062,-0.642 -2.4,-0.24 0.668,-0.108 -0.188,1.308 0.479,1.2 0.254,2.253 -0.503,3.498 -1.199,4.8 0.058,-1.578 -1.384,-1.657 -2.4,-2.16 -0.473,-1.847 -1.05,-3.59 -3.12,-3.84 -1.363,-0.399 -4.396,-0.399 -5.76,0 -3.34,0.524 -7.015,1.206 -7.44,4.08 -0.209,1.417 1.083,2.408 1.2,3.84 0.113,1.386 -1.315,2.314 -0.24,3.12 -3.048,-0.711 -4.781,-2.737 -6,-5.28 -0.158,0 -0.318,0 -0.479,0 -0.582,0.378 -1.063,0.858 -1.44,1.44 -0.898,0.699 -1.699,1.5 -2.398,2.4 -1.01,2.499 -6.568,5.57 -6.721,8.88 -0.132,2.852 3.403,4.167 2.881,7.92 0,0.8 0,1.6 0,2.4 0.03,0.591 0.036,1.156 -0.24,1.44 -1.57,-0.59 -2.807,-1.515 -4.08,-2.4 -0.724,-7.516 -4.752,-11.729 -8.4,-16.32 -1.1,-1.3 -2.3,-2.5 -3.6,-3.6 -3.486,-3.074 -7.161,-5.959 -11.521,-8.16 4.32,1.465 9.983,4.909 14.641,7.92 1.556,1.006 3.254,2.892 4.56,3.12 4.197,0.735 6.826,-3.9 9.84,-5.76 2.421,-2.22 4.74,-4.54 6.961,-6.96 0.724,-0.638 1.298,-1.423 1.921,-2.16 4.405,-2.073 10.049,-2.911 16.079,-3.36 0.801,0 1.601,0 2.399,0 4.914,0.126 8.102,1.979 10.08,5.04 8,0.4 17.68,0.4 25.68,0 1.202,-4.958 4.024,-8.296 6.96,-11.52 9.591,-1.451 18.174,-3.907 23.04,-10.08 1.262,1.541 1.452,4.147 3.12,5.28 -5.61,2.39 -9.973,6.028 -13.438,10.561 6.917,-3.48 21.973,-13.036 26.398,-0.72 0,0.8 0,1.6 0,2.4 -0.816,1.341 -1.344,2.976 -2.88,3.6 -0.274,0.074 -1.222,0.833 -0.24,0.72 3.855,-0.305 8.939,0.619 12,-0.48 0,-0.08 0,-0.16 0,-0.24 1.118,-0.882 2.029,-1.971 3.12,-2.88 2.062,-0.821 4.072,-1.688 6.96,-1.68 0.801,0 1.602,0 2.4,0 5.652,0.347 10.671,1.328 15.12,2.88 0.104,0.295 0.307,0.493 0.72,0.48 0.859,1.061 1.819,2.021 2.88,2.88 0.071,0.488 0.48,0.639 0.72,0.96 1.412,1.62 2.933,3.14 4.553,4.559 z M 231.16,140.4 c 3.879,-8.278 -7.964,-5.858 -9.842,-2.16 -1.38,1.18 -2.658,2.46 -3.84,3.84 0.046,0.088 -0.251,0.477 -0.238,0.48 1.418,0.417 9.633,0.765 12,0 1.197,-0.386 1.596,-1.858 1.92,-2.16 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "m 189.641,73.2 c -2.378,-2.048 -6.428,-3.216 -6.72,-6.96 -0.235,-3.004 3.245,-6.624 5.04,-8.64 14.64,-16.448 30.219,-34.852 37.92,-57.12 -5.94,21.393 -17.129,40.542 -30.24,56.64 -2.393,2.938 -6.256,6.135 -4.08,9.84 0.699,0.901 1.5,1.701 2.4,2.4 5.498,1.692 7.546,12.942 3.12,17.52 -0.24,0 -0.48,0 -0.722,0 -0.729,0.15 -2.065,-0.308 -2.398,0.24 -0.983,0.103 -1.538,-0.222 -2.16,-0.48 0.101,-2.691 2.549,-7.794 0.24,-10.8 -0.627,-1.053 -1.43,-1.93 -2.4,-2.64 z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "m 222.28,23.52 c 0.512,-1.97 0.479,-4.484 1.44,-6 0.398,9.602 3.115,16.884 6.24,23.76 -4.489,-3.111 -6.63,-8.571 -7.683,-15.12 0.003,-0.88 0.003,-1.76 0.003,-2.64 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path9",
    d: "m 222.28,23.52 c 0,0.88 0,1.76 0,2.64 -0.397,-0.336 -0.397,-2.304 0,-2.64 z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "m 217.24,48.96 c -0.66,5.58 -1.224,11.258 -2.399,16.32 2.587,1.306 5.846,2.074 8.64,3.36 2.712,1.248 5.655,2.59 6.96,4.56 -5.04,-1.84 -10.25,-3.51 -16.08,-4.56 -2.229,6.09 -4.021,12.618 -6.96,18 -1.221,0.675 -4.124,0.765 -5.04,-0.24 3.086,-5.635 5.647,-11.793 7.44,-18.72 -2.575,-1.651 -10.653,0.26 -11.041,-2.88 -0.539,-4.369 9.973,-1 12,-0.48 2.922,-8.438 4.814,-17.906 5.76,-28.32 1.352,0.331 0.464,2.896 0.722,4.32 0,1.36 0,2.72 0,4.08 -0.002,1.52 -0.002,3.04 -0.002,4.56 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path13",
    d: "m 217.24,40.32 c 0.556,0.885 0.084,2.796 0.238,4.08 -0.08,0 -0.16,0 -0.238,0 0,-1.36 0,-2.72 0,-4.08 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path15",
    d: "m 232.36,44.64 c 0.571,-0.398 2.789,-0.398 3.36,0 -1.119,0 -2.24,0 -3.36,0 z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "m 235.721,44.64 c -0.929,0.662 -5.655,1.318 -8.4,2.16 -2.994,0.918 -4.982,2.952 -7.198,2.4 2.078,-3.522 7.354,-3.846 12.238,-4.56 1.119,0 2.24,0 3.36,0 z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path19",
    d: "m 223.48,60 c 0.733,-3.907 1.603,-7.679 4.562,-9.36 -1.146,3.494 -2.597,6.685 -2.642,11.28 -0.683,0.917 0.191,3.392 -0.479,4.32 -0.771,0.21 -0.498,-0.623 -0.96,-0.72 -0.207,-0.993 -0.123,-2.277 -0.48,-3.12 -0.001,-0.8 -0.001,-1.6 -0.001,-2.4 z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path21",
    d: "m 293.32,53.28 c 1.896,-0.106 3.372,-0.628 4.32,-1.68 -0.037,1.806 -2.195,3.563 -3.12,5.28 -0.766,0.755 -1.788,1.252 -2.397,2.16 -2.615,1.696 -6.191,3.362 -10.32,2.16 -0.734,3.906 -2.471,6.81 -6,7.92 0.692,-2.846 2.162,-7.837 -1.2,-9.6 -3.577,-1.875 -8.741,-0.078 -11.52,1.92 -0.618,-0.712 0.978,-1.251 0.96,-2.16 0.411,-0.309 0.941,-0.497 0.96,-1.2 1.29,-1.27 2.808,-2.313 4.08,-3.6 2.071,-1.046 4.286,-1.953 6.96,-2.4 0.88,0 1.76,0 2.64,0 2.756,0.524 5.504,1.056 8.64,1.2 1.442,0.4 4.554,0.4 5.997,0 z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path23",
    d: "m 108.28,55.2 c -0.615,-1.063 -1.257,-2.103 -1.92,-3.12 1.094,-0.127 2.556,1.443 4.562,1.2 1.442,0.399 4.556,0.399 6,0 3.138,-0.142 5.853,-0.708 8.64,-1.2 0.88,0 1.76,0 2.642,0 6.278,1.08 10.235,4.483 12.96,9.12 -3.232,-2.314 -12.38,-4.237 -13.682,0.96 -0.536,2.142 0.361,4.644 0.96,6.72 -3.84,-0.72 -5.317,-3.801 -6,-7.68 -3.071,0.974 -7.742,-0.08 -10.08,-1.92 -0.209,-0.354 -0.357,-0.761 -0.96,-0.72 -0.698,-0.9 -1.5,-1.701 -2.398,-2.4 0.037,-0.6 -0.373,-0.751 -0.724,-0.96 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path25",
    d: "m 125.56,52.08 c 0.336,-0.397 2.304,-0.397 2.642,0 -0.882,0 -1.762,0 -2.642,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path29",
    d: "m 223.48,60 c 0,0.8 0,1.6 0,2.4 -0.397,-0.258 -0.397,-2.141 0,-2.4 z"
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "path31",
    d: "m 349.721,84.72 c -0.023,-6.296 -1.287,-11.353 -1.92,-17.04 5.122,12.878 8.803,27.197 17.76,36.24 -4.021,8.459 -8.635,16.325 -12.24,25.2 -0.261,0.06 -0.162,0.478 -0.479,0.48 0.678,0.506 1.426,-0.965 1.92,-1.44 13.356,-14.533 24.622,-31.193 34.561,-49.44 1.377,-2.53 2.411,-5.373 4.562,-7.44 -5.161,15.682 -14.579,31.338 -24.24,45.12 -7.203,10.275 -15.118,19.408 -23.521,29.04 -2.37,2.719 -7.385,8.476 -5.761,12 2.021,4.384 9.313,1.646 8.643,8.4 -0.456,4.584 -6.194,8.882 -9.842,11.52 -2.251,1.629 -4.905,4.004 -7.681,4.802 -2.143,0.614 -4.672,0.104 -4.8,-1.92 -0.141,-2.224 4.976,-4.9 6.96,-6.24 2.299,-1.553 6.753,-3.793 6.72,-6.24 -0.045,-3.372 -10.709,-4.551 -10.8,-9.84 -5.063,6.209 -11.501,21.577 -5.04,30.722 1.42,1.618 2.94,3.139 4.563,4.56 6.062,8.219 18.026,-3.423 26.158,1.2 -6.079,0.961 -10.993,3.084 -14.881,6.24 0.612,0.906 1.636,1.403 2.4,2.158 0.08,0 0.16,0 0.24,0 0.697,0.9 1.499,1.701 2.397,2.4 1.188,0.732 1.646,2.195 2.88,2.88 3.462,3.917 5.812,9.512 7.44,16.08 1.565,6.313 3.203,13.235 7.2,16.319 2.955,2.279 11.581,3.092 12.479,-1.92 0.358,-1.998 -0.314,-4.416 -0.96,-6 -2.127,-5.248 -6.913,-10.77 -7.199,-17.281 0,-1.118 0,-2.238 0,-3.358 1.072,-4.849 4.032,-7.81 8.88,-8.88 0.882,0 1.762,0 2.642,0 8.811,0.908 10.438,15.398 1.92,17.76 -1.741,-0.816 -2.598,-2.521 -3.359,-4.318 2.354,-0.977 3.979,-2.375 3.359,-5.28 -0.776,-3.644 -7.13,-3.58 -7.2,0.72 -0.396,0.966 -0.396,3.594 0,4.561 0.356,2.443 1.672,3.929 2.88,5.521 0.78,0.979 1.66,1.858 2.643,2.642 0.262,0.616 0.604,1.151 1.198,1.438 8.289,9.093 4.073,26.007 -9.841,26.16 -0.96,0 -1.92,0 -2.88,0 -7.473,-1.009 -12.91,-4.052 -17.04,-8.4 -0.971,-14.789 -4.104,-27.414 -12.479,-34.8 0.021,3.909 1.91,7.305 3.357,10.8 2.818,6.796 4.294,14.781 5.763,23.521 0.703,4.203 0.769,11.31 2.88,14.16 1.097,1.481 3.501,2.719 5.52,3.601 2.395,1.045 4.989,2.017 5.28,3.601 0.27,1.465 -1.435,4.282 -2.16,6.239 -1.691,4.55 -2.729,8.108 -3.6,13.2 -0.412,2.406 -1.271,5.859 -0.723,7.681 0.667,2.205 4.483,2.406 4.802,5.04 -7.968,0.448 -13.419,-5.965 -20.159,-6 -2.163,-0.012 -2.87,1.057 -4.802,0 -0.857,0.102 -1.153,0.766 -1.198,1.68 -1.455,-1.359 -0.273,-3.599 0.238,-5.039 -2.706,-0.064 -3.195,1.146 -5.04,-0.239 -1.02,0.182 -1.068,1.33 -1.438,2.16 -2.041,-3.151 1.076,-6.328 4.08,-6.722 0.88,0 1.76,0 2.64,0 4.497,0.943 7.309,3.574 12,4.32 2.525,-5.314 4.555,-11.127 6.96,-16.561 -3.555,-2.605 -7.614,-4.705 -11.277,-7.2 -0.99,-1.171 -2.438,-1.884 -3.603,-2.88 -1.102,-0.738 -1.832,-1.848 -3.12,-2.4 -0.777,-0.98 -1.659,-1.859 -2.64,-2.641 -0.56,-0.161 -0.645,-0.797 -1.2,-0.959 -5.186,-6.512 -11.214,-11.932 -11.28,-21.602 -0.05,-7.392 7.032,-10.775 5.763,-19.68 -0.379,-2.643 -1.955,-4.46 -3.842,-6 -1.181,-1.38 -2.46,-2.661 -3.841,-3.84 -3.496,-4.424 -7.011,-8.829 -9.84,-13.922 0.717,-2.163 1.943,-3.815 2.4,-6.238 -1.067,-0.105 -1.271,0.648 -1.92,0.96 -0.854,0.506 -1.789,0.931 -2.4,1.681 -1.175,0.346 -1.787,1.254 -2.88,1.68 -2.161,-0.398 -3.646,-1.478 -6.24,-1.439 -1.046,-0.398 -3.754,-0.398 -4.8,0 -1.018,-0.057 -1.699,0.221 -2.398,0.48 2.386,6.015 6.276,10.521 10.078,15.119 1.5,1.699 3.103,3.301 4.801,4.801 4.215,4.025 9.469,7.013 14.882,9.84 -3.688,0.455 -8.42,0.574 -13.2,0.96 -4.984,0.401 -13.43,-0.317 -14.16,3.36 -0.62,3.121 2.215,6.363 3.602,8.158 1.966,2.549 3.729,4.189 5.521,6.24 0.938,1.141 1.979,2.182 3.12,3.12 0.085,0.313 0.422,0.377 0.479,0.72 2.94,3.141 5.98,6.182 9.12,9.12 -0.011,0.411 0.179,0.622 0.48,0.722 0.542,1.137 1.201,2.156 0.96,4.078 -3.577,3.463 -9.229,4.854 -12.48,8.641 -0.979,0.781 -1.859,1.66 -2.64,2.641 -0.796,0.83 -3.55,2.357 -1.68,3.6 1.388,1.013 2.479,2.321 3.117,4.08 -1.442,0.438 -2.771,-0.973 -4.317,-1.68 -1.521,-0.695 -3.272,-1.193 -5.04,-1.92 -4.25,-1.745 -9.261,-5.369 -14.4,-3.12 -1.096,0.215 -1.358,-0.399 -2.159,-0.479 -1.005,-0.113 -1.112,1.912 -1.681,1.439 -1.022,-2.04 0.857,-3.102 1.2,-4.561 -2.718,-1.073 -3.466,2.369 -5.76,0.479 -1.071,0.209 -1.382,1.181 -1.683,2.16 -2.012,-3.907 2.139,-6.877 5.762,-7.438 0.881,0 1.761,0 2.641,0 3.521,0.5 7.511,4.135 11.521,4.318 3.913,0.18 13.428,-3.554 15.119,-7.439 1.567,-3.599 -0.479,-7.414 -2.88,-10.319 -2.46,-2.66 -5.02,-5.22 -7.68,-7.681 -4.099,-4.104 -12.174,-17.063 -3.84,-21.84 2.533,-1.453 5.658,-1.271 9.357,-1.92 1.2,0 2.4,0 3.603,0 0,-0.16 0,-0.32 0,-0.479 -0.94,-1.14 -1.98,-2.181 -3.12,-3.12 -5.223,-6.139 -9.658,-13.063 -13.92,-20.16 -4.748,2.053 -9.769,3.834 -13.682,6.721 3.11,1.207 6.502,2.138 7.921,5.039 -1.246,-0.474 -1.745,0.444 -3.119,0.961 -9.854,-4.853 -11.773,14.381 -2.16,12.959 0.957,0.482 0.348,2.532 2.397,1.92 -0.833,1.713 -3,1.726 -5.277,1.44 -0.57,3.53 4.143,1.776 4.56,4.32 0.039,0.28 0.438,0.202 0.721,0.239 -0.106,0.691 -1.031,0.566 -1.199,1.201 -1.976,0.814 -4.574,0.336 -6.479,-0.24 -0.04,-0.28 -0.38,-0.262 -0.72,-0.24 -0.676,-0.444 -1.229,-1.012 -2.16,-1.2 -2.27,-2.29 -3.707,-5.414 -4.32,-9.36 0,-1.84 0,-3.68 0,-5.52 0,-0.48 0,-0.96 0,-1.439 0.956,-4.645 1.917,-9.283 4.08,-12.721 0.816,-0.624 1.813,-1.066 2.4,-1.92 15.342,-10.512 34.376,-24.602 50.64,-36.24 3.306,-2.366 11.002,-5.419 8.16,-11.76 -0.558,-1.241 -1.278,-1.795 -2.88,-2.4 1.484,-0.926 3.522,-0.154 5.278,0 0.843,-1.878 1.648,-3.792 2.642,-5.52 1.196,-1.363 2.477,-2.643 3.84,-3.84 0.859,-0.421 1.838,-0.723 2.399,-1.44 -4.757,-1.245 -6.938,-5.063 -9.359,-8.64 -0.957,3.44 0.834,7.484 1.438,9.36 -1.236,0.602 -2.022,1.656 -2.88,2.64 -0.646,1.033 -1.415,1.945 -1.921,3.12 -8.883,0.076 -15.272,2.645 -22.8,4.08 -1.053,-0.118 -3.753,0.412 -2.399,-0.72 0.628,-1.054 1.027,-2.332 0.962,-4.08 -1.368,0.312 -2.53,0.83 -3.841,1.2 -2.008,0.143 -3.271,0.01 -1.682,-1.2 1.003,-1.317 1.331,-3.309 1.682,-5.28 -2.709,0.092 -6.178,0.292 -8.399,-1.2 -0.241,0.335 0.711,1.519 0.72,2.4 -3.747,-1.292 -6.744,-3.336 -7.199,-7.92 0.434,-0.973 1.229,1.58 2.642,1.2 0.729,0.399 3.11,0.399 3.84,0 0.678,0.198 0.622,-0.338 1.2,-0.24 -0.306,1.296 -1.559,1.644 -1.92,2.88 2.125,2.303 6.614,2.093 9.84,0.96 0.8,0 1.6,0 2.397,0 2.972,0.31 5.203,1.357 7.2,2.64 3.597,-0.282 7.471,1.332 10.32,0.24 1.818,-4.533 -6.963,-4.389 -11.04,-5.04 -8.235,-1.315 -16.184,-1.085 -16.32,-9.6 0,-0.08 0,-0.16 0,-0.24 -1.204,0.156 -3.033,-0.315 -3.84,0.24 -1.854,-0.588 4.801,-1.502 6.48,-1.68 2.158,0 4.317,0 6.479,0 3.843,0.558 7.816,0.983 10.561,2.64 -0.229,0.632 -0.465,2.056 0,2.64 2.921,2.32 6.893,-1.225 9.359,-2.4 -1.01,-1.482 -4.026,-2.129 -6.24,-2.64 -2.441,-0.564 -5.324,-0.398 -6.72,-2.16 0.35,-0.61 0.457,-1.463 1.44,-1.44 0.579,-0.46 1.928,-0.151 2.88,-0.24 4.18,0.7 8.414,1.346 12,2.64 -0.928,-6.04 4.104,-7.784 4.08,-13.68 1.021,0.658 1.378,1.982 1.198,3.84 1.939,-1.296 4.604,-5.117 4.08,-8.88 0.879,-0.443 1.507,1.176 2.159,2.16 1.32,1.984 2.185,4.999 3.603,7.2 -0.75,1.348 -1.035,3.8 0,5.04 0.298,0.502 0.695,0.902 1.198,1.2 -0.142,0.499 -0.505,0.775 -0.721,1.2 -0.543,0.999 -0.919,1.506 -0.96,2.4 -0.054,1.167 1.223,2.594 1.2,2.88 -0.12,1.527 -2.521,1.556 -2.16,3.6 -0.65,1.377 1.559,1.957 2.16,2.88 0.017,0.704 0.549,0.891 0.96,1.2 4.847,7.896 -2.771,18.785 -5.28,25.68 9.723,-10.998 15.029,-26.411 16.32,-45.84 0.556,-0.885 0.084,-2.796 0.24,-4.08 0.397,-3.042 0.397,-7.759 0,-10.8 -0.163,-1.371 0.309,-3.363 -0.246,-4.328 z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "path33",
    d: "m 220.841,76.56 c -2.983,2.937 -4.43,7.41 -7.2,10.56 0.047,-3.717 3.253,-9.667 6.24,-12 0.721,-0.563 3.196,-2.075 3.6,-1.2 -0.981,0.78 -1.861,1.66 -2.64,2.64 z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path37",
    d: "m 114.521,77.52 c 2.625,-2.095 7.457,-3.884 11.76,-2.16 -4.35,1.399 -8.711,4.189 -7.68,10.08 0.388,2.213 2.413,3.535 2.88,5.28 -3.611,0.979 -5.504,-1.209 -7.2,-2.88 -2.752,3.836 -8.851,6.527 -14.398,3.12 5.611,-1.669 8.36,-6.199 11.52,-10.32 1.138,-0.94 2.178,-1.979 3.118,-3.12 z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path39",
    d: "m 280.601,74.64 c 0.96,0 1.92,0 2.88,0 6.711,1.529 9.536,6.944 13.44,11.28 0.779,0.98 1.659,1.861 2.64,2.64 1.375,0.945 2.508,2.133 4.8,2.16 -3.366,2.715 -10.559,2.292 -12.72,-1.2 -0.514,-0.526 -0.747,-1.333 -1.438,-1.68 -1.26,0.501 -1.854,1.665 -2.882,2.4 -1.391,0.704 -3.438,0.93 -5.04,0.24 6.146,-4.434 2.983,-14.66 -4.56,-14.88 0.612,-0.667 2.058,-0.501 2.88,-0.96 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path41",
    d: "m 133.96,78 c 0.647,-0.398 2.95,-0.398 3.6,0 -1.2,0 -2.4,0 -3.6,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path45",
    d: "m 193.96,87.12 c 0.333,-0.547 1.67,-0.089 2.398,-0.24 -0.33,0.547 -1.668,0.09 -2.398,0.24 z"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path47",
    d: "m 387.881,100.56 c 0.806,-4.235 1.79,-9.569 4.318,-11.28 -0.087,2.313 -0.887,3.913 -0.721,6.479 -0.555,0.885 -0.083,2.796 -0.239,4.08 -0.397,0.729 -0.397,3.111 0,3.84 0.156,1.284 -0.313,3.195 0.239,4.08 -0.145,4.792 1.789,8.76 1.681,12.72 -3.435,-2.966 -4.214,-8.587 -5.278,-13.92 0,-1.999 0,-3.999 0,-5.999 z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "path49",
    d: "m 12.76,97.68 c 0.073,-3.193 -0.515,-5.725 -0.96,-8.4 1.729,1.036 2.677,3.616 3.36,6 1.53,5.352 1.425,12.38 -0.24,18 -0.864,2.916 -2.148,6.021 -4.08,7.2 0.221,-4.347 2.104,-9.09 1.92,-14.64 0.4,-2.162 0.4,-5.998 0,-8.16 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path51",
    d: "m 193.48,90.48 c 0.414,-0.398 2.466,-0.398 2.88,0 -0.96,0 -1.92,0 -2.88,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path53",
    d: "m 203.801,90.48 c 0.414,-0.398 2.466,-0.398 2.88,0 -0.96,0 -1.92,0 -2.88,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path55",
    d: "m 213.881,90.48 c 0.413,-0.398 2.466,-0.398 2.88,0 -0.96,0 -1.92,0 -2.88,0 z"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "path57",
    d: "m 193.48,90.48 c 0.96,0 1.92,0 2.88,0 1.583,0.86 3.277,3.752 2.642,5.28 -1.04,0 -2.08,0 -3.12,0 -1.524,-0.847 -3.245,-3.616 -2.402,-5.28 z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "path59",
    d: "m 203.801,90.48 c 0.96,0 1.92,0 2.88,0 1.696,0.704 2.081,2.719 2.88,4.32 0,0.24 0,0.48 0,0.72 -0.718,0.483 -2.265,0.136 -3.358,0.24 -1.526,-0.846 -3.309,-3.553 -2.402,-5.28 z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "path61",
    d: "m 213.881,90.48 c 0.96,0 1.92,0 2.88,0 3.152,0.763 2.434,5.361 -0.24,5.28 -2.02,-0.061 -2.574,-2.942 -3.12,-5.04 0.279,0.039 0.426,-0.053 0.48,-0.24 z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "path63",
    d: "m 186.76,91.2 c 1.468,0.619 2.116,3.044 2.16,4.32 -2.687,0.128 -3.324,-2.53 -2.16,-4.32 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path67",
    d: "m 190.84,99.36 c 7.92,-0.4 17.52,-0.4 25.438,0 -8.477,0 -16.958,0 -25.438,0 z"
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "path69",
    d: "m 186.28,124.56 c -0.777,-1.562 -3.612,-4.954 -4.078,-9.12 -0.66,-5.905 0.55,-14.153 6.479,-13.68 0.625,-0.496 0.335,-1.905 0.96,-2.4 0.4,0 0.8,0 1.2,0 8.479,0 16.96,0 25.438,0 0.091,0.951 -0.22,2.3 0.24,2.88 0,0.88 0,1.76 0,2.64 0,1.76 0,3.52 0,5.28 0.229,7.829 -4.151,11.047 -9.12,13.68 -0.85,0.51 -1.925,0.795 -2.64,1.44 -4.56,1.846 -11.507,6.136 -16.08,1.68 -0.698,-0.9 -1.498,-1.7 -2.399,-2.4 z m 2.881,-15.12 c 0.334,-1.161 1.11,-4.157 -0.24,-4.8 -2.902,0.378 -2.997,3.563 -3.36,6.48 -0.397,0.729 -0.397,3.112 0,3.84 0.562,3.856 2.481,8.867 6.24,9.12 0.234,-4.084 -2.601,-7.151 -2.64,-11.76 0,-0.96 0,-1.92 0,-2.88 z m 6.48,-0.24 c 0.137,-1.028 1.268,-3.929 -0.24,-4.32 -2.273,-0.592 -2.883,2.555 -3.12,4.8 -0.397,1.125 -0.397,3.915 0,5.04 0.94,3.229 1.997,7.59 5.762,7.2 0.171,-3.385 -2.271,-6.201 -2.4,-10.08 -0.002,-0.88 -0.002,-1.76 -0.002,-2.64 z m 8.16,10.56 c 0.761,-2.612 -1.432,-5.451 -1.68,-8.88 -0.19,-2.625 0.673,-4.085 0.238,-6 -6.265,-0.462 -4.124,15.245 1.442,14.88 z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "path71",
    d: "m 159.4,109.92 c 6.437,-4.765 14.032,-8.368 23.28,-10.32 -1.382,1.338 -3.116,2.324 -4.56,3.6 -2.276,1.804 -4.317,3.844 -6.24,6 -3.544,4.376 -6.787,9.054 -6.72,17.04 -1.458,-1.902 -2.514,-4.208 -2.642,-7.44 0,-0.8 0,-1.6 0,-2.4 0,-0.4 0,-0.8 0,-1.2 -3.526,0.632 -6.063,2.257 -8.398,4.08 -1.104,0.458 -2.416,3.128 -3.12,2.4 0.784,-3.295 2.708,-5.452 4.318,-7.92 0.98,-0.78 1.86,-1.66 2.642,-2.64 0.796,-0.084 1.041,-0.719 1.44,-1.2 z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "path73",
    d: "m 228.761,105.36 c -2.178,-1.983 -4.521,-3.8 -6.96,-5.52 8.94,1.379 17.135,5.585 23.52,10.32 1.37,1.51 2.851,2.912 4.32,4.32 1.471,2.369 3.214,4.466 3.84,7.68 -0.941,-0.576 -1.456,-1.584 -2.398,-2.16 -2.276,-2.043 -4.916,-3.723 -8.399,-4.56 -0.053,-0.187 -0.201,-0.279 -0.479,-0.24 -0.557,0.885 -0.083,2.796 -0.239,4.08 -0.438,2.604 -1.183,4.896 -2.4,6.72 -0.693,-7.705 -3.604,-13.193 -7.68,-17.52 -0.946,-1.14 -1.986,-2.18 -3.125,-3.12 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path75",
    d: "m 391.24,99.84 c 0,1.28 0,2.56 0,3.84 -0.398,-0.728 -0.398,-3.111 0,-3.84 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path79",
    d: "m 216.521,104.88 c 0.08,0 0.16,0 0.24,0 -0.158,1.682 0.316,3.997 -0.24,5.28 0,-1.76 0,-3.52 0,-5.28 z"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "path85",
    d: "m 354.521,173.041 c 3.747,-4.253 7.146,-8.854 9.601,-14.4 -3.188,-2.1 -12.546,0.639 -13.198,-3.36 -0.378,-2.305 1.937,-3.471 3.84,-3.6 3.927,-0.266 8.143,2.024 11.76,1.92 5.999,-11.922 9.749,-26.091 11.521,-42.24 0.868,0.17 0.329,1.749 0.479,2.64 0,2 0,4 0,6 -0.552,13.528 -3.496,24.664 -6.96,35.28 5.637,2.184 11.296,4.339 16.8,6.96 1.686,0.801 3.699,1.634 4.801,3.12 -7.574,-2.104 -14.978,-4.383 -23.278,-5.76 -3.193,6.646 -6.634,13.047 -11.04,18.48 -1.86,1.66 -3.62,3.419 -5.28,5.28 -3.65,1.875 -7.933,7.283 -13.2,7.199 -1.275,-0.021 -3.588,-0.842 -3.84,-2.16 -0.622,-3.258 4.916,-5 6.96,-6.239 3.06,-1.853 5.176,-3.548 7.44,-5.52 1.294,-1.1 2.494,-2.3 3.594,-3.6 z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "path87",
    d: "m 25.48,112.08 c 0.233,-0.006 0.188,-0.293 0.24,-0.48 1.439,3.73 1.278,7.746 1.92,11.52 1.865,10.964 5.692,21.435 9.84,30.48 4.409,-0.298 15.931,-4.496 15.84,1.2 -0.067,4.379 -9.786,2.076 -13.438,3.6 4.018,8.727 10.856,17.678 19.92,23.28 2.387,1.478 8.254,3.5 7.92,6.48 -0.137,1.221 -2.206,2.347 -3.84,2.4 -5.173,0.168 -8.985,-4.854 -12.48,-6.48 -0.393,-0.648 -0.938,-1.143 -1.68,-1.439 -1.1,-1.301 -2.3,-2.5 -3.6,-3.601 -0.3,-0.742 -0.792,-1.288 -1.44,-1.681 -3.901,-5.377 -7.65,-10.909 -10.08,-17.759 -8.623,1.217 -15.967,3.712 -23.76,5.76 0.04,-1 1.243,-0.837 1.68,-1.44 1.254,-0.426 2.375,-0.985 3.36,-1.68 5.417,-2.502 10.938,-4.902 16.8,-6.96 -3.455,-9.666 -6.114,-20.126 -6.96,-32.4 -0.158,-1.682 0.317,-3.997 -0.24,-5.28 0,-0.32 0,-0.64 0,-0.96 -0.002,-1.52 -0.002,-3.04 -0.002,-4.56 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path89",
    d: "m 25.48,116.64 c -0.422,-0.833 -0.367,-4.517 0,-4.56 0,1.52 0,3.04 0,4.56 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path91",
    d: "m 105.64,114 c 1.604,-0.399 4.877,-0.399 6.48,0 -2.16,0 -4.32,0 -6.48,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path95",
    d: "m 378.521,114 c 0.399,1.444 0.399,4.557 0,6 0,-2 0,-4 0,-6 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path97",
    d: "m 162.521,118.8 c -0.396,-0.259 -0.396,-2.141 0,-2.4 0,0.8 0,1.6 0,2.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path99",
    d: "m 1.96,123.6 c 0.808,-0.399 3.271,-0.399 4.08,0 -1.36,0 -2.72,0 -4.08,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path101",
    d: "m 397.961,123.6 c 0.887,-0.399 3.433,-0.399 4.318,0 -1.438,0 -2.879,0 -4.318,0 z"
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "path103",
    d: "m 6.04,123.6 c 3.563,0.112 7.336,0.769 10.318,1.92 2.611,1.007 6.282,2.27 6.24,5.28 -1.804,0.37 -3.313,-1.155 -4.8,-1.92 -4.581,-2.359 -10.553,-3.406 -16.32,-4.8 0.106,-0.213 0.211,-0.429 0.48,-0.48 1.362,0 2.722,0 4.082,0 z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "path105",
    d: "m 384.039,127.2 c 3.801,-2.041 8.316,-3.364 13.922,-3.6 1.438,0 2.88,0 4.318,0 0.08,0 0.159,0 0.239,0 -1.374,1.509 -3.663,1.268 -5.52,1.68 -3.596,0.798 -7.519,1.932 -10.802,3.6 -1.508,0.766 -2.993,2.367 -4.801,1.92 -0.269,-0.756 -0.021,-0.543 0,-1.44 0.803,-0.8 1.858,-1.347 2.644,-2.16 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path107",
    d: "m 104.68,127.44 c 0.259,-0.397 2.141,-0.397 2.4,0 -0.8,0 -1.6,0 -2.4,0 z"
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "path111",
    d: "m 15.16,152.64 c -0.114,-8.846 -1.949,-15.971 -4.08,-22.8 5.132,2.506 7.521,14.185 6.96,22.56 -0.161,2.393 -0.629,6.567 -2.4,7.2 -0.699,-1.781 0.224,-5.183 -0.48,-6.96 z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "path113",
    d: "m 385.961,147.36 c 0.988,-7.17 1.969,-14.351 6.96,-17.52 -1.567,5.556 -3.646,12.671 -3.842,20.4 -0.56,2.561 -0.081,6.159 -0.238,9.12 -2.815,0.204 -2.086,-5.077 -2.88,-7.68 0,-1.44 0,-2.88 0,-4.32 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path117",
    d: "m 149.32,137.28 c 0.261,-0.397 2.143,-0.397 2.4,0 -0.8,0 -1.6,0 -2.4,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path119",
    d: "m 252.521,137.28 c 0.259,-0.397 2.144,-0.397 2.4,0 -0.801,0 -1.601,0 -2.4,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path121",
    d: "m 385.961,147.36 c 0,1.44 0,2.88 0,4.32 -0.399,-0.887 -0.399,-3.433 0,-4.32 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d50100"
    },
    id: "path123",
    d: "m 163.48,159.601 c -0.211,-2.452 0.233,-4.247 1.682,-5.04 0.053,0.907 0.755,1.165 0.96,1.92 0.153,1.045 -0.313,2.713 0.238,3.36 0,1.92 0,3.84 0,5.76 0.159,2.721 -0.317,6.079 0.24,8.4 0,2.08 0,4.16 0,6.24 0.158,2.161 -0.316,4.958 0.24,6.72 0,0.721 0,1.439 0,2.16 2.321,0.495 6.756,1.845 4.56,4.561 -1.778,-0.221 -2.256,-1.744 -4.08,-1.921 -1.145,2.489 -0.218,6.396 -1.438,9.601 -4.218,0.957 -2.066,-6.887 -2.88,-9.359 -2.413,-0.525 -6.351,-1.619 -5.04,-4.318 1.781,-0.748 2.864,2.342 4.8,1.438 0.558,-1.683 0.082,-4.397 0.24,-6.479 0.558,-1.683 0.082,-4.398 0.24,-6.479 0,-2.08 0,-4.16 0,-6.24 0.558,-2.966 0.079,-6.964 0.238,-10.324 z"
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "path125",
    d: "m 137.08,188.641 c -1.158,-10.44 -1.512,-21.688 -2.4,-32.398 0.502,0.138 0.687,0.595 1.44,0.48 1.725,1.712 0.96,4.774 0.96,7.2 10e-4,7.688 0,16.954 0,24.718 z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "path127",
    d: "m 268.12,156.72 c 0.445,-0.033 0.803,-0.158 0.961,-0.479 -0.276,10.284 -1.17,22.028 -2.16,32.399 0.159,-10.48 -0.319,-21.6 0.239,-31.681 0.36,-0.04 0.886,0.087 0.96,-0.239 z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "path133",
    d: "m 24.04,170.64 c -1.698,-1.741 -3.837,-3.043 -5.521,-4.8 5.424,-0.137 8.464,4.171 12,6.72 0.39,1.131 1.373,1.667 2.16,2.4 2.719,3.841 5.729,7.392 7.2,12.479 -0.213,0.105 -0.429,0.211 -0.48,0.479 -1.063,0.024 -0.833,-1.247 -1.68,-1.438 -2.222,-3.938 -5.29,-7.03 -8.16,-10.32 -1.739,-1.94 -3.579,-3.78 -5.519,-5.52 z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "path137",
    d: "m 377.321,169.2 c 2.563,-1.358 4.424,-3.416 8.159,-3.6 -0.139,1.416 -2.816,2.276 -3.84,3.6 -0.9,0.7 -1.7,1.5 -2.399,2.4 -1.401,0.997 -2.585,2.215 -3.601,3.6 -0.98,0.78 -1.86,1.66 -2.641,2.64 -1.354,1.74 -2.916,3.253 -4.319,5.04 -1.297,1.651 -2.135,3.954 -4.08,5.04 0.244,-5.681 4.629,-9.288 7.2,-13.44 1.46,-1.26 2.818,-2.62 4.08,-4.08 0.797,-0.084 1.042,-0.718 1.441,-1.2 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path141",
    d: "m 123.16,171.12 c 0.396,0.259 0.396,2.142 0,2.4 0,-0.8 0,-1.6 0,-2.4 z"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "path147",
    d: "m 364.841,193.68 c 0.138,0.982 1.104,1.135 1.198,2.16 -3.479,-2.918 -7.604,-5.195 -12.479,-6.72 1.858,-3.236 6.279,0.688 8.4,1.68 0.86,1.061 1.82,2.02 2.881,2.88 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path149",
    d: "m 25.48,203.041 c 0.259,-0.396 2.143,-0.396 2.4,0 -0.8,0 -1.6,0 -2.4,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path155",
    d: "m 36.76,212.4 c 0.397,0.336 0.397,2.304 0,2.64 0,-0.879 0,-1.76 0,-2.64 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path161",
    d: "m 128.44,256.561 c 0.261,-0.396 2.143,-0.396 2.4,0 -0.799,0 -1.6,0 -2.4,0 z"
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "path165",
    d: "m 133.72,280.561 c -0.546,-4.414 -0.608,-9.312 -2.4,-12.479 3.534,-0.786 7.604,-1.038 11.28,-1.682 -0.438,0.844 -0.592,1.97 -0.96,2.882 -1.811,-0.456 -4.403,-0.25 -6,0.239 0.031,2.129 0.486,3.832 0.72,5.761 1.813,-0.431 4.138,-0.345 5.762,-0.96 0.56,0.73 -0.43,1.963 -0.48,2.88 -1.423,-0.634 -3.471,-0.002 -5.04,0 0.166,2.073 0.705,3.774 0.72,6 2.962,-0.318 5.954,-0.604 7.682,-2.159 0.401,0.653 -0.194,2.355 -0.24,3.357 -3.813,0.27 -7.267,0.896 -10.8,1.44 -0.161,-1.682 0.313,-3.996 -0.244,-5.279 z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "path167",
    d: "m 124.84,269.281 c 1.106,6.49 3.563,11.636 5.52,17.279 -3.021,1.856 -6.257,-2.019 -8.64,-3.601 -2.39,-1.587 -4.501,-2.93 -6.479,-3.841 0.627,3.531 2.408,7.988 4.078,11.279 -1.319,0.119 -2.14,0.74 -3.358,0.959 0.188,-2.619 -1.025,-5.137 -1.92,-7.68 -1.235,-3.509 -1.419,-7.527 -4.8,-8.64 0.801,-0.879 2.398,-0.961 3.6,-1.44 4.551,2.729 8.663,5.897 13.2,8.642 -1.061,-4.302 -2.365,-8.355 -4.32,-11.761 1.123,-0.313 2.182,-0.693 3.119,-1.196 z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "path169",
    d: "m 282.761,270.48 c 1.33,0.43 2.527,0.992 3.84,1.438 1.552,4.931 2.521,10.438 4.562,14.88 1.439,-3.68 3.323,-6.915 3.841,-11.521 1.336,0.185 2.198,0.843 3.357,1.199 -3.013,4.748 -4.826,10.692 -6.72,16.563 -0.988,-0.292 -1.742,-0.816 -2.88,-0.96 -0.7,-5.461 -2.712,-9.606 -3.84,-14.642 -1.239,1.428 -1.935,3.455 -2.643,5.279 -0.733,1.898 -1.276,3.95 -1.438,6.24 -1.035,-0.564 -2.325,-0.875 -3.36,-1.439 1.785,-2.104 2.462,-4.821 3.84,-8.399 1.246,-3.231 2.926,-5.339 1.441,-8.638 z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "path171",
    d: "m 103.48,277.682 c 2.016,5.985 4.628,11.37 7.682,16.319 -1.474,0.368 -2.368,1.312 -3.842,1.681 -1.609,-6.311 -4.569,-11.271 -7.438,-16.32 1.28,-0.479 2.493,-1.027 3.598,-1.68 z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "path173",
    d: "m 307.48,281.761 c 8.132,-0.354 14.159,9.565 8.4,15.841 -5.229,5.695 -18.363,2.432 -17.04,-7.92 0.512,-3.996 3.804,-7.709 8.64,-7.921 z m -5.519,10.8 c 0.706,4.896 7.063,7.188 10.56,4.563 4.127,-3.104 2.337,-10.598 -0.96,-12.24 -0.998,-0.498 -2.44,-0.678 -4.08,-0.479 -3.729,0.445 -6.245,3.142 -5.52,8.156 z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "path177",
    d: "m 91.48,283.682 c 0.936,-0.267 1.736,-0.664 2.4,-1.201 2.702,5.459 5.102,11.221 9.12,15.36 -0.176,0.224 -0.438,0.363 -0.722,0.479 -0.912,0.604 -2.229,0.81 -2.88,1.681 -0.158,0 -0.318,0 -0.479,0 -0.562,-3.761 -2.757,-5.884 -4.08,-8.881 -0.24,-0.319 -0.396,-0.724 -0.72,-0.96 -0.547,0.333 -0.091,1.671 -0.24,2.4 -0.556,1.043 -0.083,3.115 -0.24,4.561 0,1.52 0,3.039 0,4.561 0.051,0.409 -0.409,0.62 0,0.719 -3.569,-1.229 -6.936,-4.741 -10.56,-6.719 1.208,3.752 2.527,7.392 5.04,9.84 -0.985,0.693 -2.106,1.254 -3.36,1.681 -1.87,-5.729 -3.697,-12.612 -7.92,-15.841 0.765,-0.756 2.115,-0.926 2.88,-1.68 3.46,2.14 6.487,4.713 10.08,6.719 0.166,0.477 0.64,0.642 1.2,0.723 0.558,-1.521 0.082,-4.079 0.24,-6.001 0,-0.079 0,-0.159 0,-0.239 0.556,-0.965 0.083,-2.957 0.238,-4.318 0.003,-0.964 0.003,-1.925 0.003,-2.884 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path179",
    d: "m 330.761,282.721 c 0.336,-0.396 2.304,-0.396 2.64,0 -0.88,0 -1.76,0 -2.64,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path185",
    d: "m 257.081,289.921 c 0.728,-0.399 3.109,-0.399 3.84,0 -1.28,0 -2.561,0 -3.84,0 z"
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "path187",
    d: "m 143.8,289.921 c 1.36,0 2.72,0 4.08,0 3.773,0.515 7.461,0.794 11.52,1.681 2.658,0.58 8.265,1.951 8.16,4.799 -0.064,1.81 -4.398,4.304 -6.24,5.521 -4.785,3.17 -9.057,5.432 -11.76,9.6 -7.115,-0.687 -12.988,-6.95 -9.6,-14.397 0.834,-1.007 1.716,-1.965 2.398,-3.12 -1.282,0.156 -3.193,-0.314 -4.08,0.239 -25.02,3.166 -44.354,18.569 -65.038,27.841 -7.188,3.223 -15.31,6.604 -23.521,7.199 -11.641,0.848 -17.75,-4.321 -18.24,-15.359 1.979,7.865 6.375,13.582 17.28,12.96 8.804,-0.503 16.985,-4.493 24.72,-8.159 14.951,-7.084 28.29,-15.223 43.92,-21.841 8.259,-3.5 17.434,-6.27 26.401,-6.964 z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "path189",
    d: "m 317.079,303.841 c 0.104,-0.457 0.519,-0.604 0.479,-1.2 0.555,2.7 7.918,6.758 7.92,1.44 0.002,-2.724 -4.027,-4.655 -4.08,-7.921 -0.1,-6.221 8.564,-5.639 11.761,-1.439 -0.366,0.912 -0.967,1.594 -1.198,2.641 -0.5,-3.156 -7.183,-5.754 -7.44,-1.68 -0.184,2.883 4.396,4.846 4.32,8.399 -0.11,5.122 -6.866,6.022 -10.802,2.64 -0.57,-0.864 -2.134,-1.64 -0.96,-2.88 z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "path191",
    d: "m 79,306.24 c -1.114,4.74 -6.271,9.826 -12.48,8.16 -9.084,-2.438 -9.563,-17.063 1.44,-18.479 3.273,-0.422 4.662,0.565 7.2,1.681 0.698,0.899 1.5,1.699 2.398,2.399 0.525,1.233 0.995,2.524 1.44,3.84 0.002,0.8 0.002,1.598 0.002,2.399 z m -3.36,2.16 c 3.306,-9.326 -10.334,-13.728 -12.96,-6.24 -1.894,5.398 2.508,9.898 7.2,9.601 3.024,-0.193 5.049,-1.353 5.76,-3.361 z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "path195",
    d: "m 53.8,319.2 c -2.521,1.802 -6.773,1.868 -10.32,2.641 0.557,-6.239 -1.396,-13.317 -2.64,-17.76 4.034,-1.116 10.488,-1.688 13.2,0.96 0.739,0.939 1.621,1.738 2.398,2.641 1.667,2.418 1.283,6.588 -0.238,8.879 -0.779,0.901 -1.659,1.7 -2.4,2.639 z m -8.88,-13.92 c 0.447,4.913 1.483,9.235 2.16,13.92 10.155,0.34 8.995,-16.291 -2.16,-13.92 z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "path207",
    d: "m 218.44,333.841 c -4.723,-10.096 5.828,-17.483 16.32,-13.92 0,1.279 0,2.56 0,3.84 -5.758,-4.504 -14.959,-2.379 -14.16,5.761 0.482,4.918 4.8,7.383 10.562,6.721 0.08,0 0.158,0 0.238,0 0.376,-1.469 0.417,-4.538 0,-6 0.032,-0.592 0.036,-1.156 -0.238,-1.439 0,-0.078 0,-0.158 0,-0.238 1.521,0 3.04,0 4.561,0 0.005,0.563 -0.413,0.707 -0.24,1.438 -0.559,2.161 -0.081,5.356 -0.238,7.92 -3.939,1.185 -10.051,0.958 -13.2,-0.72 -1.285,-1.043 -2.591,-2.058 -3.605,-3.363 z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "path211",
    d: "m 154.601,321.841 c 0.107,-1.067 -0.171,-1.75 -0.479,-2.399 1.92,0 3.84,0 5.76,0 6.28,0.121 9.175,3.625 10.8,8.399 0.004,1.044 0.08,2.159 -0.24,2.88 -1.195,4.323 -3.941,7.098 -8.88,7.68 -2.479,0 -4.96,0 -7.438,0 0.31,-0.648 0.587,-1.332 0.479,-2.397 C 155,331.84 155,326.001 154.601,321.841 z m 3.839,14.399 c 6.9,0.6 10.25,-5.182 8.16,-10.079 -1.044,-2.445 -3.974,-4.56 -8.16,-4.562 -0.399,4.322 -0.399,10.321 0,14.641 z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "path213",
    d: "m 176.68,322.081 c 0.079,-1.119 -0.187,-1.894 -0.479,-2.642 1.6,0 3.198,0 4.8,0 -0.245,1.035 -0.621,1.938 -0.48,3.359 -0.398,3.521 -0.398,8.721 0,12.24 -0.141,1.42 0.235,2.324 0.48,3.357 -1.602,0 -3.2,0 -4.8,0 0.293,-0.746 0.559,-1.521 0.479,-2.64 0.4,-3.995 0.4,-9.674 0,-13.674 z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "path215",
    d: "m 187.72,322.32 c 0.17,-1.289 -0.273,-1.967 -0.479,-2.881 2.078,0 4.158,0 6.238,0 6.863,-0.479 8.236,9.631 1.92,10.801 0.944,2.016 2.5,3.42 3.842,5.039 0.698,0.902 1.5,1.701 2.398,2.4 0.003,0.478 0.655,0.307 0.48,0.961 -1.452,0.012 -3.022,0.142 -3.842,-0.479 -1.18,-1.382 -2.459,-2.661 -3.84,-3.841 -0.045,-0.194 -0.239,-0.239 -0.238,-0.479 -0.83,-0.851 -1.386,-1.978 -2.4,-2.64 -0.08,0 -0.16,0 -0.24,0 -0.397,0.808 -0.397,3.271 0,4.078 -0.139,1.34 0.277,2.123 0.48,3.121 -1.602,0 -3.2,0 -4.802,0 0.333,-0.787 0.566,-1.674 0.48,-2.881 0.403,-3.839 0.403,-9.358 0.003,-13.199 z m 3.841,6.481 c 6.076,0.901 6.246,-8.141 0,-7.199 -0.4,1.841 -0.4,5.356 0,7.199 z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "path217",
    d: "m 211.48,319.682 c -0.076,0.563 -0.379,0.899 -0.24,1.68 -0.397,4.48 -0.397,10.641 0,15.119 -0.139,0.779 0.164,1.117 0.24,1.683 0,0.079 0,0.157 0,0.237 -1.6,0 -3.2,0 -4.8,0 0.258,-0.621 0.583,-1.176 0.479,-2.158 0.398,-4.32 0.398,-10.319 0,-14.641 0.14,-0.778 -0.163,-1.117 -0.239,-1.681 0.524,-0.921 3.647,-0.507 4.56,-0.239 z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "path219",
    d: "m 241.721,319.682 c 3.44,-0.561 7.919,-0.08 11.76,-0.24 -0.461,0.898 -0.896,1.822 -1.2,2.881 -0.586,-0.215 -1.038,-0.561 -1.92,-0.479 -1.044,-0.557 -3.115,-0.083 -4.56,-0.239 0,2.08 0,4.16 0,6.239 0.38,-0.021 0.915,0.115 0.96,-0.239 2.016,-0.097 3.76,0.08 5.52,0.239 -0.366,0.912 -0.967,1.595 -1.198,2.642 -0.278,-0.201 -0.645,-0.316 -1.199,-0.24 -0.885,-0.555 -2.797,-0.083 -4.08,-0.239 0,2 0,4 0,6 1.125,0.399 3.914,0.399 5.04,0 1.509,0.149 2.03,-0.688 3.359,-0.721 -0.32,0.88 -0.567,1.833 -0.722,2.881 -3.368,0.394 -8.394,0.403 -11.76,0 -0.006,-0.565 0.413,-0.707 0.24,-1.44 0.397,-4.641 0.397,-10.959 0,-15.6 0.173,-0.738 -0.246,-0.881 -0.24,-1.445 z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "path239",
    d: "m 138.521,367.439 c 1.521,0 3.04,0 4.562,0 4.091,0.391 7.628,1.332 11.04,2.399 0,3.438 0,6.882 0,10.32 -3.576,-2.347 -7.112,-4.729 -12.96,-4.802 -0.336,-0.396 -2.306,-0.396 -2.642,0 -3.676,0.004 -6.061,1.301 -8.16,2.882 -1.14,0.938 -2.18,1.979 -3.118,3.118 -1.803,2.521 -3.353,5.289 -3.602,9.359 -0.397,1.604 -0.397,4.877 0,6.48 1.077,8.308 5.683,15.396 14.88,15.6 6.077,0.135 11.141,-2.154 15.12,-5.279 0.582,-0.074 1.063,-1.478 1.44,-0.961 0,3.2 0,6.4 0,9.603 -0.525,0.354 -1.292,0.468 -1.682,0.96 -3.489,1.629 -7.283,2.955 -12,3.357 -1.438,0 -2.88,0 -4.318,0 -5.748,-0.569 -10.109,-2.528 -13.92,-5.039 -0.287,-0.594 -0.822,-0.938 -1.44,-1.198 -0.699,-0.901 -1.5,-1.701 -2.4,-2.4 -0.016,-0.702 -0.549,-0.892 -0.96,-1.198 -2.496,-3.584 -4.395,-7.767 -5.04,-13.201 0,-1.601 0,-3.198 0,-4.799 0.715,-6.408 2.942,-11.3 6,-15.359 1.46,-1.262 2.82,-2.62 4.08,-4.08 4.077,-2.883 8.788,-5.131 15.12,-5.762 z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "path241",
    d: "m 169.24,368.641 c 3.921,-0.56 8.88,-0.08 13.198,-0.24 -0.013,0.31 -0.308,0.334 -0.238,0.723 -0.653,2.786 -1.521,5.359 -1.44,8.88 -0.4,10.32 -0.4,22.317 0,32.642 0.062,3.457 0.706,6.334 1.68,8.879 0,0.16 0,0.319 0,0.479 -4.398,0 -8.8,0 -13.199,0 0.047,-0.192 0.24,-0.237 0.239,-0.479 0.6,-2.683 1.438,-5.121 1.44,-8.398 0.398,-10.721 0.398,-23.12 0,-33.84 -0.107,-3.338 -0.717,-6.169 -1.68,-8.646 z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "path245",
    d: "m 196.121,368.4 c 13.919,0.16 28.479,-0.319 42,0.24 -1.437,3.362 -3.082,6.519 -4.562,9.84 -3.545,-1.896 -7.766,-3.114 -13.438,-2.881 -0.562,10.239 -0.08,21.521 -0.239,32.159 -0.021,0.343 -0.04,0.681 0.239,0.722 0.154,1.125 -0.313,2.873 0.238,3.601 0.032,3.008 0.865,5.215 1.44,7.68 0,0.08 0,0.16 0,0.24 -4.24,-0.16 -9.12,0.319 -12.96,-0.24 0.559,-2.481 1.376,-4.702 1.438,-7.68 0.557,-0.806 0.084,-2.636 0.24,-3.84 0.562,-10.08 0.08,-21.2 0.24,-31.681 0,-0.24 0,-0.479 0,-0.722 -1.046,-0.397 -3.755,-0.397 -4.801,0 -4.296,-0.057 -7.004,1.476 -9.839,2.882 0.004,-3.439 0.004,-6.879 0.004,-10.32 z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "path247",
    d: "m 247.961,371.041 c -0.413,-1.111 -2.521,-1.793 -2.4,-2.641 4.88,0 9.76,0 14.642,0 0,0.24 0,0.479 0,0.721 1.092,8.107 5.815,12.582 8.641,18.96 3.042,-5.918 7.868,-11.331 8.64,-18.722 0,-0.318 0,-0.641 0,-0.959 3.89,0.908 11.408,-1.229 14.643,0 0.75,0.285 0.378,0.123 -0.24,0.721 -0.9,0.699 -1.701,1.499 -2.4,2.398 -6.15,8.567 -10.663,18.775 -15.84,28.319 0.159,3.683 -0.317,7.999 0.24,11.28 -0.021,3.299 0.843,5.717 1.438,8.398 -0.063,0.156 0.118,0.289 0.24,0.239 -3.017,1.2 -9.271,-0.393 -13.2,0.24 1.1,-3.542 1.802,-7.481 1.922,-12 -0.159,-2.722 0.317,-6.079 -0.239,-8.399 -5.193,-9.692 -9.731,-20.032 -16.087,-28.555 z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "path257",
    d: "m 181.24,438.961 c 0.758,-6.959 10.084,-11.159 16.8,-6.96 0.697,0.9 1.5,1.7 2.398,2.399 0.86,1.46 1.442,3.196 1.92,5.04 0,1.04 0,2.078 0,3.118 -0.921,11.45 -20.316,11.681 -21.118,0 0,-1.197 0,-2.397 0,-3.597 z m 4.321,2.88 c -0.442,5.666 7.057,8.517 10.8,5.04 3.896,-3.612 1.729,-11.821 -2.398,-13.2 -3.982,-1.329 -8.216,1.076 -8.4,5.04 -0.401,0.492 -0.401,2.628 -0.002,3.12 z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "path259",
    d: "m 210.04,432.961 c 0.105,-1.067 -0.17,-1.749 -0.479,-2.4 4.16,0 8.32,0 12.479,0 0.398,0 0.801,0 1.198,0 -0.424,1.416 -1.271,2.408 -1.68,3.842 -1.114,-0.727 -2.534,-1.146 -4.56,-0.96 -0.489,-0.553 -1.993,-0.089 -2.881,-0.239 -0.399,1.441 -0.399,4.556 0,6 2.158,0 4.318,0 6.479,0 -0.655,1.345 -1.395,2.604 -2.16,3.84 -1.169,-0.591 -2.445,-1.072 -4.318,-0.96 -0.398,1.046 -0.398,3.754 0,4.8 -0.16,1.761 0.273,2.925 0.479,4.32 -1.601,0 -3.2,0 -4.8,0 -0.129,-0.929 0.428,-1.172 0.239,-2.16 0.404,-4.804 0.404,-11.282 0.004,-16.083 z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "path277",
    d: "m 102.28,461.521 c 1.762,0 3.521,0 5.28,0 5.454,0.705 9.593,2.728 13.2,5.278 1.451,1.432 2.831,2.932 4.32,4.32 2.953,4.167 5.102,9.138 5.76,15.6 0,1.36 0,2.723 0,4.08 -0.641,6.399 -3.003,11.076 -6,15.12 -1.063,0.859 -2.021,1.819 -2.88,2.88 -0.619,0.262 -1.154,0.606 -1.44,1.2 -17.496,12.865 -43.552,1.245 -42.96,-20.64 0,-0.88 0,-1.763 0,-2.643 1.508,-15.127 10.361,-22.914 24.72,-25.195 z m 10.8,11.76 c -9.581,-7.556 -25.582,-1.063 -24.722,12 -0.396,0.568 -0.396,2.789 0,3.357 -0.928,13.765 15.088,23.688 25.682,15.36 0.899,-0.699 1.701,-1.499 2.398,-2.4 1.669,-2.251 3.097,-4.742 3.36,-8.397 0.399,-1.604 0.399,-4.877 0,-6.48 -0.259,-4.859 -2.116,-8.124 -4.32,-11.04 -0.697,-0.901 -1.497,-1.701 -2.398,-2.4 z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "path279",
    d: "m 284.921,461.521 c 1.68,0 3.357,0 5.04,0 5.565,0.673 9.773,2.703 13.438,5.278 1.313,1.408 2.673,2.77 4.08,4.08 3.09,4.11 5.287,9.113 6,15.603 0,1.52 0,3.038 0,4.56 -0.682,6.278 -2.938,10.982 -6,14.88 -1.22,1.021 -2.34,2.141 -3.359,3.36 -7.122,7.178 -26.052,8.36 -33.841,0.96 -1.406,-1.474 -2.811,-2.95 -4.317,-4.32 -3.027,-4.413 -5.56,-9.323 -5.761,-16.56 0,-0.803 0,-1.603 0,-2.4 0.223,-6.577 2.529,-11.069 5.278,-15.12 1.466,-1.574 2.985,-3.094 4.563,-4.56 3.982,-2.897 8.766,-4.994 14.879,-5.761 z m 17.519,24.96 c -1.103,-9.03 -6.813,-16.805 -16.8,-16.563 -17.494,0.424 -18.272,25.509 -7.92,33.84 4.264,3.433 14.337,4.842 18.96,0.24 0.9,-0.699 1.7,-1.499 2.398,-2.4 1.633,-2.208 3.071,-4.606 3.359,-8.157 0.403,-1.763 0.403,-5.197 0.003,-6.96 z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "path281",
    d: "m 140.2,462.721 c -0.056,-0.186 -0.008,-0.474 -0.24,-0.479 3.041,-0.562 7.119,-0.081 10.56,-0.24 0.116,0.283 0.256,0.544 0.48,0.72 5.097,9.245 12.172,18.271 18.72,27.36 1.836,2.548 4.91,7.719 6.72,8.64 0,-7.84 0,-15.68 0,-23.52 -0.02,-0.38 0.115,-0.916 -0.238,-0.96 -0.156,-1.204 0.313,-3.035 -0.24,-3.84 -0.032,-3.011 -0.865,-5.216 -1.44,-7.683 0.039,-0.276 -0.053,-0.427 -0.24,-0.479 3.843,-0.4 9.359,-0.4 13.2,0 -0.758,2.762 -1.667,5.373 -1.68,8.88 -0.562,9.92 -0.08,20.88 -0.24,31.2 0,0.08 0,0.16 0,0.239 0.156,1.202 -0.313,3.033 0.24,3.841 -0.005,3.284 0.733,5.826 1.92,7.92 -4.32,0 -8.64,0 -12.96,0 0.021,-0.341 0.04,-0.681 -0.24,-0.722 -3.69,-8.255 -10.724,-16.216 -16.56,-23.761 -1.759,-2.272 -3.896,-5.543 -5.28,-6.479 -0.554,0.726 -0.084,2.475 -0.24,3.6 0,3.2 0,6.4 0,9.602 0.146,2.124 -0.524,3.681 0,5.521 0.156,1.204 -0.313,3.034 0.24,3.84 0.057,3.305 0.903,5.816 1.68,8.4 -4.398,0 -8.8,0 -13.198,0 0.758,-2.763 1.667,-5.373 1.68,-8.88 0.398,-10.881 0.398,-23.44 0,-34.32 0.002,-3.685 -1.605,-5.759 -2.644,-8.4 z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "path283",
    d: "m 202.36,462.241 c 7.12,-0.563 15.28,-0.08 22.802,-0.24 5.856,0.702 10.343,2.777 14.158,5.521 1.021,1.221 2.142,2.341 3.36,3.358 3.083,4.117 5.508,8.894 6.24,15.36 0,1.438 0,2.88 0,4.317 -0.695,6.507 -2.631,11.771 -5.761,15.843 -0.9,0.697 -1.7,1.499 -2.399,2.397 -4.153,3.287 -10.017,4.863 -16.8,5.521 -1.521,0 -3.04,0 -4.563,0 -5.601,-0.16 -11.84,0.317 -17.04,-0.24 1.026,-3.213 1.604,-6.877 1.92,-10.8 0,-10.08 0,-20.16 0,-30.24 -0.296,-3.938 -0.966,-7.507 -1.917,-10.797 z m 20.161,7.68 c -2.241,-0.559 -5.52,-0.081 -8.16,-0.24 0,4.48 0,8.96 0,13.44 -0.397,5.04 -0.397,11.76 0,16.8 0,2.24 0,4.48 0,6.72 1.604,0.4 4.877,0.4 6.48,0 10.813,-0.063 16.878,-4.882 17.04,-15.6 0.396,-0.729 0.396,-3.111 0,-3.84 -0.83,-10.051 -6.019,-15.742 -15.36,-17.28 z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "path285",
    d: "m 324.039,462.48 c 2.49,-1.109 7.032,-0.167 10.319,-0.479 0.24,0.319 0.396,0.725 0.721,0.96 7.064,12.535 16.16,23.04 24,34.8 0.241,0.479 0.602,0.841 0.96,1.2 0.399,-8.4 0.399,-18.479 0,-26.88 0.089,-3.927 -0.987,-6.69 -1.681,-9.84 0,-0.08 0,-0.16 0,-0.24 4.32,0.159 9.28,-0.319 13.2,0.24 -1.171,2.908 -1.892,6.269 -1.92,10.317 -0.399,10.32 -0.399,22.32 0,32.643 0.03,3.57 0.57,6.63 1.92,8.88 0,0.08 0,0.16 0,0.24 -4.319,0 -8.64,0 -12.96,0 -2.011,-6.653 -6.868,-11.662 -10.8,-16.8 -3.414,-4.464 -6.755,-8.764 -10.08,-13.2 -0.298,-0.502 -0.698,-0.902 -1.2,-1.2 0,1.2 0,2.397 0,3.6 -0.553,0.647 -0.085,2.315 -0.24,3.36 0,2 0,4 0,6 0.159,2.801 -0.316,6.239 0.24,8.64 -0.042,3.725 0.903,6.457 1.681,9.36 0,0.08 0,0.16 0,0.24 -4.239,-0.16 -9.12,0.317 -12.961,-0.24 0.771,-3.31 1.829,-6.331 1.683,-10.56 0.397,-9.603 0.397,-20.882 0,-30.48 0.251,-4.731 -1.533,-7.427 -2.882,-10.561 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path287",
    d: "m 176.44,498.721 c -0.398,-7.278 -0.398,-16.237 0,-23.52 0,7.84 0,15.68 0,23.52 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ec712a"
    },
    id: "path321",
    d: "m 127.24,536.881 c 44.045,0.002 94.196,-0.003 140.158,0 3.288,0 7.144,-0.544 9.12,0 0.699,0.192 0.378,-0.208 0.24,0.721 -1.025,2.414 -2.365,4.517 -3.12,7.199 -0.646,0.072 -0.431,1.01 -0.96,1.2 -48.401,-0.16 -97.438,0.32 -145.44,-0.24 0.002,-2.96 0.002,-5.92 0.002,-8.88 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path323",
    d: "m 394.36,178.561 c 1.38,-1.5 2.639,-3.122 4.563,-4.08 -0.311,0.411 -0.496,0.943 -1.2,0.96 -1.264,0.897 -2.102,2.221 -3.363,3.12 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path325",
    d: "m 379.48,194.88 c 0.86,-1.062 1.82,-2.021 2.88,-2.88 -0.859,1.061 -1.821,2.021 -2.88,2.88 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path327",
    d: "m 191.561,66.96 c 0.9,0.7 1.7,1.5 2.4,2.4 -0.901,-0.699 -1.701,-1.499 -2.4,-2.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path329",
    d: "m 192.041,75.84 c -0.875,-0.805 -1.604,-1.756 -2.4,-2.64 0.97,0.71 1.773,1.587 2.4,2.64 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path331",
    d: "m 223.961,65.52 c 0.462,0.098 0.188,0.931 0.96,0.72 0.671,-0.929 -0.203,-3.403 0.479,-4.32 0,1.44 0,2.88 0,4.32 -0.725,0.343 -1.384,0.199 -1.439,-0.72 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path335",
    d: "m 109,56.16 c 0.699,0.9 1.5,1.7 2.398,2.4 0.603,-0.041 0.751,0.369 0.96,0.72 -1.817,-0.901 -3.179,-2.261 -4.08,-4.08 0.353,0.209 0.763,0.36 0.722,0.96 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path337",
    d: "m 292.121,59.04 c 0.609,-0.908 1.634,-1.405 2.397,-2.16 -0.569,0.948 -1.547,1.491 -2.397,2.16 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path339",
    d: "m 265.001,58.08 c 0.701,-1.059 1.771,-1.747 2.64,-2.64 0.504,-0.295 0.938,-0.664 1.44,-0.96 -1.272,1.288 -2.79,2.331 -4.08,3.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path341",
    d: "m 111.4,58.56 c -0.898,-0.7 -1.699,-1.5 -2.398,-2.4 0.899,0.699 1.699,1.5 2.398,2.4 z"
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "path343",
    d: "m 262.601,66 c 1.685,-0.717 3.465,-1.335 5.28,-1.92 -2.453,3.868 -6.346,8.375 -6.48,15.36 1.731,-0.509 3.393,-1.09 5.28,-1.44 1.12,0 2.24,0 3.36,0 2.357,0.521 4.499,1.261 6.479,2.16 0.523,1.167 -3.217,-0.077 -3.84,0.72 -14.349,1.251 -19.859,11.341 -33.36,13.44 2.331,0.549 5.042,0.718 7.92,0.72 2.804,0.4 7.279,0.4 10.08,0 7.195,-0.165 12.669,-2.051 16.08,-6 2.523,2.119 -0.179,4.742 -1.68,6.24 6.122,1.558 10.786,4.573 12.72,10.32 -0.818,0.168 -1.719,-0.848 -2.64,-1.44 -2.886,-1.855 -6.778,-3.61 -11.28,-3.84 -1.521,-0.399 -4.717,-0.399 -6.24,0 -0.479,0 -0.96,0 -1.438,0 0.419,2.141 1.635,3.485 1.92,5.76 0.389,0.892 0.199,2.361 0.24,3.6 -0.194,-0.045 -0.239,-0.241 -0.48,-0.24 -7.258,-9.543 -22.523,-11.074 -37.438,-12.96 8.527,-4.592 19.253,-6.988 22.561,-16.8 0.398,-0.808 0.398,-3.272 0,-4.08 -0.027,-2.135 -2.162,-3.435 -2.398,-4.56 4.043,0.758 7.353,2.248 7.438,6.96 1.749,-2.65 2.461,-6.339 4.32,-8.88 1.173,-1.063 2.338,-2.137 3.596,-3.12 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path345",
    d: "m 140.68,65.52 c 1.593,0.807 3.054,1.746 4.08,3.12 -1.206,-1.193 -2.766,-2.034 -4.08,-3.12 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path347",
    d: "m 156.76,84.24 c 1.061,0.859 2.021,1.819 2.88,2.88 -1.06,-0.859 -2.02,-1.819 -2.88,-2.88 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path349",
    d: "m 139.48,109.44 c 0.748,-1.252 1.773,-2.228 2.88,-3.12 -0.93,1.07 -1.891,2.109 -2.88,3.12 z"
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "path351",
    d: "m 137.561,78 c 1.708,0.452 3.477,0.845 5.04,1.44 0.104,-6.182 -3.185,-11.055 -6.24,-14.88 1.407,-0.602 2.782,0.894 4.32,0.96 1.313,1.086 2.874,1.927 4.08,3.12 1.829,2.731 3.19,5.93 4.32,9.36 0.78,-4.098 3.432,-6.328 7.68,-6.96 0.454,0.838 -1.355,1.692 -1.92,2.88 -1.653,3.478 -0.214,8.081 1.92,10.32 0.86,1.061 1.82,2.021 2.88,2.88 5.079,3.801 11.118,6.642 17.521,9.12 -12.976,1.986 -26.53,3.39 -34.802,10.08 -1.105,0.893 -2.132,1.868 -2.88,3.12 -1.068,-2.688 1.026,-6.32 1.682,-8.88 0.041,-0.521 -0.853,-0.108 -1.2,-0.24 -1.523,-0.399 -4.717,-0.399 -6.24,0 -6.109,0.45 -10.343,2.776 -13.92,5.76 1.246,-5.555 6.09,-9.59 12.72,-10.56 -1.229,-1.695 -4.353,-3.971 -1.92,-6.48 3.601,3.841 8.98,5.9 16.32,6 2.722,0.4 7.119,0.4 9.84,0 3.041,0.161 5.324,-0.436 8.16,-0.48 -6.281,-2.307 -11.65,-3.878 -16.8,-6.96 -5.326,-3.187 -9.144,-6.902 -17.28,-6.96 -1.12,0 -2.24,0 -3.36,0 1.556,-1.486 4.066,-2.013 6.48,-2.64 1.198,0 2.398,0 3.599,0 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path355",
    d: "m 259.001,69.12 c 1.012,-1.228 2.078,-2.401 3.6,-3.12 -1.258,0.983 -2.423,2.057 -3.6,3.12 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path357",
    d: "m 58.12,171.601 c 0.558,0.162 0.643,0.797 1.198,0.96 0.771,0.831 1.79,1.409 2.4,2.4 -1.3,-1.019 -2.605,-2.033 -3.598,-3.36 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path359",
    d: "m 73.96,193.92 c 1.551,-1.729 3.12,-3.441 5.04,-4.8 -0.249,0.871 -1.104,1.137 -1.682,1.68 -1.26,0.898 -2.096,2.221 -3.358,3.12 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path361",
    d: "m 56.2,207.359 c 1.18,-1.379 2.46,-2.659 3.84,-3.84 -1.18,1.381 -2.459,2.663 -3.84,3.84 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path365",
    d: "m 81.4,208.8 c 0.859,-1.06 1.819,-2.02 2.88,-2.88 -0.86,1.06 -1.82,2.021 -2.88,2.88 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path373",
    d: "m 105.88,208.561 c -0.737,1.023 -1.609,1.912 -2.4,2.881 0.966,0.154 2.554,-0.313 3.12,0.24 -1.2,0 -2.398,0 -3.6,0 0.187,-1.094 1.296,-1.265 1.68,-2.16 0.558,-0.165 0.643,-0.799 1.2,-0.961 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path399",
    d: "m 327.641,191.521 c -1.063,-0.86 -2.021,-1.82 -2.88,-2.881 1.06,0.86 2.02,1.82 2.88,2.881 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path417",
    d: "m 130.36,143.521 c 0.859,-1.061 1.82,-2.021 2.882,-2.88 -0.623,0.737 -1.197,1.522 -1.922,2.16 -0.489,0.07 -0.47,0.649 -0.96,0.72 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path419",
    d: "m 124.6,149.28 c 1.82,-2.021 3.74,-3.94 5.76,-5.76 -1.819,2.021 -3.739,3.94 -5.76,5.76 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path421",
    d: "m 127.72,153.84 c 0.414,-0.786 1.266,-1.134 1.68,-1.92 0.378,-0.582 0.858,-1.062 1.44,-1.44 -0.704,1.456 -2.016,2.304 -3.12,3.36 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path423",
    d: "m 156.28,145.92 c -0.668,0.108 0.188,-1.308 -0.479,-1.2 0.34,-0.401 2.383,-0.477 2.4,0.24 -0.563,-0.077 -0.901,-0.379 -1.682,-0.24 -0.519,-0.04 -0.107,0.851 -0.239,1.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path427",
    d: "m 75.88,120.48 c 0.04,-0.28 0.379,-0.261 0.72,-0.24 -0.157,1.443 0.316,3.516 -0.24,4.56 -0.284,-1.316 0.591,-3.79 -0.48,-4.32 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path429",
    d: "m 105.16,138.96 c 0.521,-0.043 0.764,0.196 0.72,0.72 -1.045,-0.155 -2.713,0.313 -3.36,-0.24 0.88,0 1.76,0 2.642,0 0.133,0 0.271,-0.194 0,-0.24 -0.002,-0.08 -0.002,-0.16 -0.002,-0.24 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path431",
    d: "m 116.44,126.96 c 0.838,-1.349 -2.392,-2.723 -1.438,-3.36 0.249,1.355 2.869,2.065 1.68,3.36 -0.082,0 -0.161,0 -0.242,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path433",
    d: "m 78.04,99.36 c 0.578,-1.324 0.518,1.785 0.479,2.64 -0.703,-0.336 0.225,-2.304 -0.479,-2.64 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path435",
    d: "m 65.8,123.6 c 0.859,-1.06 1.819,-2.02 2.88,-2.88 -0.86,1.061 -1.82,2.021 -2.88,2.88 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path437",
    d: "m 109.72,134.88 c 0.412,0.309 0.944,0.496 0.96,1.2 -0.808,-0.152 -2.229,0.31 -2.64,-0.24 1.522,0.061 3.11,0.132 1.68,-0.96 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path439",
    d: "m 71.32,126.96 c 0.699,-0.901 1.5,-1.701 2.4,-2.4 -0.699,0.901 -1.499,1.701 -2.4,2.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path441",
    d: "m 136.6,222.48 c 0.454,-0.268 0.841,-0.601 1.44,-0.722 -0.675,0.446 -0.457,1.784 -0.48,2.882 -0.788,-0.251 0.523,-2.603 -0.96,-2.16 z"
  }), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "path443",
    d: "m 40.6,101.76 c 7.13,-9.35 11.332,-21.628 15.36,-34.08 0.234,4.971 -1.892,11.699 -1.682,18.24 -0.558,1.522 -0.082,4.079 -0.238,6 0.089,1.661 -0.129,4.121 0,5.04 0.156,1.842 -0.317,4.318 0.238,5.76 1.155,19.965 6.537,35.703 16.32,47.04 -2.447,-7.525 -10.312,-17.403 -4.8,-26.16 1.06,-0.859 2.02,-1.819 2.88,-2.88 0.151,-2.311 -1.533,-2.787 -2.16,-4.32 1.572,-1.422 0.953,-4.917 -0.479,-6 1.089,-1.37 2.684,-4.488 0.96,-6.48 2.109,-3.089 2.562,-7.839 5.76,-9.84 -0.339,4.739 2.142,6.658 3.84,9.36 0.396,-1.445 0.311,-3.371 1.44,-4.08 0.704,0.336 -0.226,2.304 0.479,2.64 0.961,3.719 4.691,5.814 3.36,11.04 3.875,-1.085 7.958,-1.961 12.24,-2.64 1.105,0.013 2.347,-0.106 3.118,0.24 4.605,4.03 -11.294,3.223 -11.76,6.24 2.666,1.141 6.041,4.433 9.36,2.64 0.46,-0.58 0.15,-1.929 0.24,-2.88 2.671,-1.729 6.733,-2.065 10.56,-2.64 2.16,0 4.32,0 6.48,0 2.383,0.418 5.042,0.558 6.96,1.44 -0.791,0.303 -2.833,-0.201 -4.32,0 -0.045,8.366 -7.013,8.232 -15.6,9.6 -4.193,0.668 -14.726,0.75 -11.28,5.76 3.384,-0.536 6.344,-0.101 9.12,-0.72 2.653,-0.592 4.798,-2.792 7.68,-2.64 0.8,0 1.6,0 2.4,0 3.062,0.915 6.981,1.445 9.358,-0.48 0.08,0 0.16,0 0.24,0 1.189,-1.295 -1.431,-2.005 -1.68,-3.36 0.563,-0.005 0.707,0.414 1.438,0.24 0.649,0.398 2.95,0.398 3.602,0 1.336,0.209 2.048,-1.462 2.64,-1.2 -0.247,4.633 -3.443,6.317 -6.72,7.92 -0.778,-0.793 0.524,-1.541 0.479,-2.4 -2.355,1.009 -5.137,1.873 -8.16,0.96 -0.601,2.044 0.554,4.406 1.44,5.76 1.43,1.092 -0.159,1.021 -1.68,0.96 -1.329,-0.351 -2.512,-0.85 -3.841,-1.2 -0.352,1.157 0.254,3.423 0.96,4.32 0,0.08 0,0.16 0,0.24 0.271,0.046 0.134,0.241 0,0.24 -0.881,0 -1.761,0 -2.641,0 -7.503,-1.457 -13.901,-4.018 -22.8,-4.08 -1.224,-2.376 -2.352,-4.85 -5.04,-5.76 0.68,-1.48 1.743,-2.577 1.68,-4.8 0.558,-1.044 0.083,-3.117 0.24,-4.56 -0.34,-0.021 -0.68,-0.04 -0.72,0.24 -0.611,1.469 -1.496,2.664 -2.16,4.08 -0.9,0.7 -1.701,1.5 -2.4,2.4 -1.327,0.672 -2.65,1.348 -4.318,1.68 3.807,2.753 7.579,5.542 8.64,11.04 2.058,-0.077 3.472,-0.769 5.521,-0.24 -2.696,1.277 -4.354,4.581 -2.641,7.92 1.184,2.301 4.647,3.985 7.44,6 15.687,11.318 30.653,22.072 46.56,33.361 2.492,1.77 6.108,3.988 7.44,5.76 2.551,3.394 2.887,9.289 3.6,13.439 -0.044,0.204 0.093,0.227 0.24,0.24 0.096,2.016 -0.08,3.76 -0.24,5.52 -0.584,4.616 -2.287,8.113 -5.52,10.08 -0.601,0.122 -0.986,0.454 -1.44,0.721 -0.997,0.203 -2.07,0.328 -2.88,0.721 -0.984,0.023 -1.967,0.047 -2.64,-0.24 -0.984,-0.215 -1.666,-0.732 -2.4,-1.2 1.069,-0.211 1.512,-1.048 1.92,-1.92 1.259,-0.739 3.985,-0.015 3.36,-2.64 -1.814,-0.184 -4.207,0.031 -5.28,-1.44 1.568,0.05 1.844,-1.194 2.4,-2.159 2.257,-0.662 4.253,-0.05 5.52,-1.92 2.209,-3.263 0.403,-10.338 -2.399,-11.521 -1.964,-0.563 -3.621,0.638 -5.039,0.479 -1.207,-0.134 -2.322,-2.08 -3.12,-0.479 0.232,-3.206 4.81,-4.149 7.68,-5.521 -3.781,-2.938 -8.844,-4.596 -13.44,-6.72 -4.285,6.513 -8.278,13.32 -13.198,19.2 -0.9,0.699 -1.7,1.5 -2.4,2.4 -0.384,0.896 -1.493,1.065 -1.68,2.16 1.199,0 2.398,0 3.6,0 4.343,0.706 8.413,0.609 10.8,2.879 6.104,5.801 -0.999,15.739 -4.56,20.159 -1.865,1.575 -3.327,3.554 -5.04,5.28 -0.194,0.045 -0.239,0.241 -0.48,0.24 -0.898,0.699 -1.699,1.5 -2.398,2.398 0,0.08 0,0.16 0,0.24 -1.583,1.458 -2.839,3.241 -3.36,5.76 -0.396,0.729 -0.396,3.111 0,3.84 0.709,3.03 3.521,4.908 6.96,6.24 5.769,2.232 8.854,2.256 14.16,0.24 2.096,-0.796 3.828,-2.167 5.76,-2.4 0.8,0 1.602,0 2.4,0 3.562,0.805 7.254,2.604 6.24,7.2 -0.944,-0.336 -0.937,-1.625 -1.92,-1.92 -2.586,1.849 -3.072,-1.53 -6,-0.479 0.548,1.558 2.152,2.425 1.438,4.561 -0.775,0.542 -0.753,-1.375 -1.68,-1.439 -0.766,0.037 -1.058,0.545 -1.92,0.479 -8.475,-2.338 -17.488,4.896 -24,7.2 0.267,-2.773 2.199,-3.881 3.84,-5.28 0.06,-0.698 -0.452,-0.828 -0.72,-1.198 -0.859,-1.063 -1.819,-2.021 -2.881,-2.882 -1.788,-1.696 -3.851,-3.54 -6.961,-5.521 -2.021,-1.286 -6.797,-2.816 -7.198,-5.039 -0.736,-4.065 4.288,-6.019 6,-8.881 2.1,-1.899 4.1,-3.899 6,-6 0.237,-0.319 0.647,-0.472 0.72,-0.959 1.06,-0.859 2.021,-1.819 2.88,-2.881 1.95,-2.77 7.157,-6.908 7.68,-11.279 0.681,-5.678 -8.357,-4.624 -13.68,-5.04 -5.198,-0.406 -9.318,-0.453 -13.68,-0.96 6.875,-3.446 13.263,-7.377 18,-12.961 0.899,-0.698 1.701,-1.5 2.398,-2.399 3.655,-4.264 6.958,-8.882 9.602,-14.16 -2.106,-1.149 -4.2,-1.123 -6.48,-0.96 -2.551,0.184 -5.285,1.817 -6.96,1.68 -2.676,-0.219 -4.385,-3.898 -7.2,-4.318 -0.374,2.25 2.188,3.941 2.16,6 -0.023,2.051 -2.914,4.96 -4.318,6.96 -1.769,2.514 -3.505,4.772 -4.802,6.479 -2.18,1.979 -4.26,4.061 -6.238,6.239 -6.757,7.513 2.845,15.229 3.6,22.32 0.886,8.317 -4.053,13.831 -7.44,19.2 -0.631,0.567 -1.445,0.953 -1.68,1.92 -1.54,1.34 -2.979,2.779 -4.32,4.32 -1.05,0.31 -1.509,1.211 -2.158,1.92 -5.408,4.271 -11.148,8.211 -17.28,11.76 1.925,5.914 4.479,11.199 6.72,16.8 4.703,-0.738 7.588,-3.292 12,-4.32 0.88,0 1.76,0 2.642,0 3.044,0.511 5.565,2.706 4.56,6.479 -1.029,-0.172 -0.688,-1.713 -1.68,-1.92 -1.937,1.337 -2.363,0.271 -5.04,0.24 0.308,1.934 1.308,2.851 0.479,4.799 -0.915,-0.045 -0.581,-1.338 -1.438,-1.438 -1.841,0.869 -3.308,-0.036 -5.04,0 -3.386,0.067 -6.621,2.177 -9.84,3.358 -3.297,1.212 -6.356,2.552 -10.32,2.642 0.104,-0.854 0.869,-1.052 1.2,-1.681 0.851,-0.829 1.92,-1.439 2.64,-2.399 0.613,-0.026 0.84,-0.44 1.2,-0.72 -0.584,-7.301 -1.879,-14.421 -4.32,-21.121 -0.624,-1.711 -2.576,-4.571 -2.398,-6 0.402,-3.292 8.271,-4.489 10.318,-6.48 2.471,-2.4 2.604,-10.354 3.36,-15.119 0.677,-4.248 1.265,-8.461 2.16,-12.479 1.882,-8.451 5.919,-14.618 7.438,-21.84 -2.551,0.78 -3.953,3.521 -5.278,5.76 -3.83,6.466 -6.657,16.077 -7.44,25.438 -0.105,1.261 0.13,2.305 -0.24,3.361 -0.571,1.627 -3.688,3.83 -5.28,4.799 -3.206,1.955 -7.573,3.244 -12,3.84 -0.8,0 -1.6,0 -2.398,0 -8.275,-1.023 -15.313,-5.928 -14.4,-15.84 0.946,-10.274 10.794,-14.054 11.521,-20.879 0.376,-3.537 -0.787,-6.73 -3.602,-6.961 -4.989,-0.404 -5.93,7.491 -0.479,7.44 -0.698,1.94 -1.649,3.631 -3.12,4.8 -3.315,-0.925 -5.276,-3.204 -6,-6.72 -0.347,-0.774 -0.227,-2.013 -0.24,-3.12 1.05,-4.229 3.736,-6.824 7.92,-7.92 0.801,0 1.602,0 2.4,0 4.912,1.168 8.3,3.859 8.88,9.359 0,0.881 0,1.761 0,2.641 0.751,7.214 -8.286,15.322 -8.16,22.32 0.099,5.461 7.939,6.123 12,3.358 0.9,-0.698 1.701,-1.5 2.4,-2.399 5.853,-8.787 5.621,-23.658 13.2,-30.719 1.46,-1.262 2.818,-2.621 4.079,-4.08 1.448,-0.711 2.339,-1.981 3.601,-2.882 -4.083,-2.956 -8.551,-5.528 -15.12,-6 7.13,-5.391 18.726,6.069 24.96,-0.239 1.3,-1.101 2.5,-2.301 3.6,-3.601 0.577,-0.543 1.433,-0.81 1.682,-1.68 7.48,-8.888 0.613,-24.271 -4.08,-31.2 -1.905,2.511 -3.154,4.77 -6.48,6.48 -1.801,0.926 -4.666,1.284 -4.8,3.12 -0.174,2.385 4.925,5.283 6.72,6.48 2.193,1.462 6.934,3.646 6.961,6 0.064,5.378 -7.832,0.275 -9.359,-0.721 -2.521,-1.645 -4.443,-3.089 -6.24,-4.319 -0.61,-0.991 -1.631,-1.569 -2.399,-2.4 -0.797,-0.884 -1.523,-1.836 -2.399,-2.64 -1.949,-2.782 -3.028,-6.664 0.24,-8.88 3.197,-2.169 8.829,-1.539 6.238,-7.92 -1.376,-3.391 -4.9,-6.667 -7.438,-9.6 -17.594,-20.332 -36.263,-45.209 -45.84,-72.24 2.276,2.076 3.337,5.032 4.8,7.68 10.173,18.407 21.839,36.281 36.24,50.88 -3.675,-8.726 -8.063,-16.738 -12.24,-24.96 -0.054,-0.187 -0.006,-0.474 -0.24,-0.48 0.055,-1.45 1.455,-1.568 1.908,-2.636 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path445",
    d: "m 104.68,209.521 c 0.7,-0.9 1.5,-1.701 2.4,-2.4 -0.248,0.631 -0.952,0.809 -1.2,1.439 -0.557,0.163 -0.642,0.797 -1.2,0.961 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path455",
    d: "m 103,203.28 c 0.7,-0.9 1.5,-1.7 2.398,-2.4 -0.697,0.901 -1.497,1.701 -2.398,2.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path457",
    d: "m 81.16,208.8 c 1.979,-2.18 4.06,-4.26 6.238,-6.239 -0.896,1.263 -2.222,2.099 -3.12,3.359 -1.061,0.86 -2.021,1.82 -2.88,2.88 -0.078,0 -0.158,0 -0.238,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path461",
    d: "m 46.12,295.2 c 0.663,-1.017 1.68,-1.681 2.64,-2.399 -0.719,0.96 -1.789,1.57 -2.64,2.399 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path465",
    d: "m 56.2,207.359 c 1.38,-1.18 2.658,-2.459 3.84,-3.84 0.08,0 0.16,0 0.238,0 -1.26,1.461 -2.618,2.819 -4.078,4.08 0,-0.078 0,-0.16 0,-0.24 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path467",
    d: "m 73.72,194.4 c 0.045,-0.194 0.241,-0.239 0.24,-0.48 1.262,-0.898 2.098,-2.222 3.358,-3.12 -1.098,1.302 -2.297,2.501 -3.598,3.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path469",
    d: "m 59.32,172.561 c -0.558,-0.163 -0.643,-0.798 -1.198,-0.96 -0.39,-0.572 -0.862,-1.058 -1.2,-1.68 0.874,0.804 1.602,1.755 2.398,2.64 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path471",
    d: "m 38.92,104.88 c -1.284,-1.275 0.971,-2.331 1.68,-3.12 -0.453,1.067 -1.854,1.186 -1.92,2.64 0.234,0.007 0.186,0.294 0.24,0.48 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path473",
    d: "m 353.32,129.12 c 0.379,0.517 0.859,-0.885 1.44,-0.96 -0.494,0.475 -1.242,1.946 -1.92,1.44 0.316,-0.002 0.22,-0.42 0.48,-0.48 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path475",
    d: "m 324.521,188.641 c 0.08,0 0.16,0 0.24,0 0.857,1.062 1.817,2.021 2.88,2.881 0.332,0.707 1.106,0.973 1.438,1.681 -1.618,-1.423 -3.139,-2.942 -4.558,-4.562 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path489",
    d: "m 305.561,185.76 c 0.611,-0.749 1.547,-1.173 2.4,-1.68 -0.611,0.749 -1.549,1.174 -2.4,1.68 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path501",
    d: "m 300.521,210.96 c -0.737,-1.103 -1.9,-1.776 -2.64,-2.88 1.14,0.939 2.18,1.979 3.12,3.12 -0.194,-0.045 -0.239,-0.241 -0.48,-0.24 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path503",
    d: "m 274.601,221.28 c 0.4,0 0.8,0 1.2,0 -0.393,0.646 -0.938,1.142 -1.681,1.438 0.168,-0.633 1.093,-0.508 1.198,-1.199 -0.28,-0.037 -0.678,0.044 -0.717,-0.239 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path505",
    d: "m 264.761,221.041 c 0.932,0.188 1.484,0.756 2.16,1.2 -0.16,0 -0.32,0 -0.48,0 -0.622,-0.259 -0.893,-0.868 -1.68,-0.96 0,-0.08 0,-0.16 0,-0.24 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path507",
    d: "m 264.521,192 c 0.587,-0.854 1.584,-1.296 2.4,-1.92 -0.587,0.854 -1.584,1.296 -2.4,1.92 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path509",
    d: "m 326.199,132.24 c 0.855,-0.984 1.644,-2.038 2.88,-2.64 -0.996,0.843 -1.849,1.83 -2.88,2.64 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path513",
    d: "m 337.001,108.72 c 0.632,0.249 0.808,0.952 1.438,1.2 -0.242,0.478 -0.415,1.025 -0.96,1.2 0.216,-0.424 0.579,-0.701 0.721,-1.2 -0.502,-0.298 -0.901,-0.698 -1.199,-1.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path517",
    d: "m 220.841,76.56 c 0.779,-0.98 1.659,-1.86 2.64,-2.64 -0.78,0.98 -1.66,1.861 -2.64,2.64 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path519",
    d: "m 291.641,89.52 c -0.675,-0.285 -0.893,-1.027 -1.438,-1.44 -1.053,0.629 -1.487,1.872 -2.882,2.16 1.025,-0.735 1.622,-1.898 2.882,-2.4 0.691,0.347 0.924,1.154 1.438,1.68 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path521",
    d: "m 111.4,80.64 c 0.939,-1.14 1.979,-2.18 3.12,-3.12 -0.939,1.141 -1.979,2.18 -3.12,3.12 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path523",
    d: "m 296.921,85.92 c 0.979,0.78 1.858,1.66 2.64,2.64 -0.981,-0.779 -1.861,-1.66 -2.64,-2.64 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path525",
    d: "m 209.561,94.8 c 0.325,0.074 0.199,0.601 0.24,0.96 -0.573,0.386 -3.825,0.386 -3.601,0 1.096,-0.104 2.643,0.243 3.358,-0.24 0.003,-0.24 0.003,-0.48 0.003,-0.72 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path527",
    d: "m 155.32,113.52 c 1.134,-1.428 2.468,-2.654 4.08,-3.6 -0.397,0.481 -0.645,1.115 -1.438,1.2 -1.025,0.657 -1.618,1.743 -2.642,2.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path529",
    d: "m 150.76,121.92 c 0,0.16 0,0.32 0,0.48 1.336,-0.424 1.742,-1.778 2.88,-2.4 -0.824,0.594 -2.331,3.604 -3.12,1.92 0.08,0 0.16,0 0.24,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path531",
    d: "m 172.36,108.96 c 1.182,-1.38 2.46,-2.66 3.842,-3.84 -1.181,1.38 -2.461,2.66 -3.842,3.84 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path533",
    d: "m 204.761,125.28 c 0.715,-0.646 1.79,-0.93 2.64,-1.44 -0.601,0.759 -1.641,1.08 -2.64,1.44 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path535",
    d: "m 188.681,126.96 c -0.901,-0.7 -1.701,-1.5 -2.4,-2.4 0.9,0.7 1.7,1.5 2.4,2.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path537",
    d: "m 245.32,110.16 c 1.646,1.235 3.177,2.586 4.32,4.32 -1.471,-1.408 -2.95,-2.81 -4.32,-4.32 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path539",
    d: "m 171.88,109.2 c 1.923,-2.156 3.964,-4.196 6.24,-6 -0.417,0.863 -1.365,1.195 -1.92,1.92 -1.382,1.18 -2.66,2.46 -3.842,3.84 -0.192,0.046 -0.237,0.241 -0.478,0.24 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path541",
    d: "m 151,121.68 c 0.704,0.728 2.016,-1.942 3.12,-2.4 -0.084,0.313 -0.424,0.377 -0.48,0.72 -1.138,0.622 -1.543,1.977 -2.88,2.4 0,-0.16 0,-0.32 0,-0.48 -0.044,-0.204 0.094,-0.226 0.24,-0.24 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path543",
    d: "m 155.32,113.52 c 1.023,-0.657 1.617,-1.743 2.642,-2.4 -0.78,0.98 -1.66,1.86 -2.642,2.64 0,-0.08 0,-0.16 0,-0.24 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path545",
    d: "m 253.48,122.16 c -0.124,0.448 -1.858,-1.444 -2.398,-2.16 0.942,0.576 1.455,1.584 2.398,2.16 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path547",
    d: "m 231.881,108.48 c -1.143,-0.94 -2.181,-1.98 -3.12,-3.12 1.139,0.94 2.179,1.98 3.12,3.12 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path551",
    d: "m 46.12,179.041 c 1.1,1.3 2.3,2.5 3.6,3.6 0.742,0.299 1.288,0.793 1.68,1.44 -2.676,-1.804 -4.916,-4.044 -6.72,-6.72 0.648,0.391 1.142,0.937 1.44,1.68 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path553",
    d: "m 355.24,181.92 c 0.699,-0.9 1.499,-1.701 2.399,-2.4 -0.698,0.901 -1.497,1.701 -2.399,2.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path555",
    d: "m 353.561,183.359 c 1.66,-1.859 3.42,-3.619 5.28,-5.279 -0.248,0.631 -0.952,0.809 -1.2,1.439 -0.9,0.698 -1.7,1.5 -2.399,2.399 -0.711,0.334 -0.972,1.111 -1.681,1.441 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path557",
    d: "m 350.921,176.641 c 1.1,-1.3 2.3,-2.5 3.6,-3.6 -1.1,1.3 -2.3,2.5 -3.6,3.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path559",
    d: "m 49.72,182.641 c -1.3,-1.1 -2.5,-2.3 -3.6,-3.6 1.3,1.1 2.5,2.299 3.6,3.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path561",
    d: "m 12.52,163.92 c 0.985,-0.695 2.106,-1.254 3.36,-1.68 -0.985,0.695 -2.106,1.254 -3.36,1.68 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path563",
    d: "m 242.44,141.84 c 0.941,-1.059 1.794,-2.207 3.12,-2.88 -1.09,0.91 -2.001,1.998 -3.12,2.88 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path567",
    d: "m 274.36,144.48 c 0.634,0.248 0.811,0.952 1.44,1.2 0.896,1.262 2.222,2.098 3.12,3.36 -1.619,-1.419 -3.14,-2.939 -4.56,-4.56 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path571",
    d: "m 266.681,155.76 c -0.039,0.281 -0.438,0.203 -0.72,0.24 0.604,-0.756 1.851,-1.632 0.479,-2.4 1.9,0.263 0.073,1.826 0.241,2.16 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path573",
    d: "m 190.601,151.2 c -1.054,-0.466 -1.721,-1.319 -2.398,-2.16 0.844,0.673 1.596,1.441 2.398,2.16 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path575",
    d: "m 127,154.32 c 0.699,-0.9 1.5,-1.701 2.398,-2.4 -0.414,0.786 -1.266,1.134 -1.68,1.92 -0.313,0.085 -0.375,0.423 -0.718,0.48 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path577",
    d: "m 110.44,156.24 c -1.3,-1.1 -2.5,-2.3 -3.6,-3.6 1.301,1.1 2.5,2.3 3.6,3.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path579",
    d: "m 124.36,149.76 c 0.045,-0.194 0.241,-0.239 0.24,-0.479 2.021,-1.82 3.94,-3.74 5.76,-5.76 0.489,-0.071 0.473,-0.649 0.96,-0.72 -2.219,2.419 -4.54,4.74 -6.96,6.959 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path581",
    d: "m 381.4,129.36 c 0.631,-0.969 1.573,-1.627 2.641,-2.16 -0.788,0.813 -1.843,1.36 -2.641,2.16 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path583",
    d: "m 15.16,152.64 c 0.702,1.776 -0.221,5.179 0.479,6.96 -1.064,-1.414 -0.199,-4.76 -0.479,-6.96 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path585",
    d: "m 217.48,142.08 c 1.182,-1.38 2.46,-2.66 3.84,-3.84 -0.058,0.343 -0.396,0.405 -0.479,0.72 -1.263,0.898 -2.099,2.222 -3.361,3.12 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path589",
    d: "m 136.12,156.72 c 2.517,0.443 0.602,5.319 1.198,7.68 0,2.8 0,5.6 0,8.4 -0.155,5.043 0.316,11.995 -0.238,15.841 0,-7.765 0,-17.031 0,-24.721 0,-2.426 0.765,-5.487 -0.96,-7.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path593",
    d: "m 25,171.84 c 1.22,1.02 2.34,2.14 3.358,3.36 C 27.14,174.181 26.02,173.061 25,171.84 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path595",
    d: "m 371.801,174.24 c 1.682,-1.838 3.305,-3.735 5.521,-5.04 -0.397,0.481 -0.645,1.116 -1.438,1.2 -1.504,1.139 -2.582,2.702 -4.083,3.84 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path597",
    d: "m 375.641,175.2 c 1.016,-1.385 2.197,-2.603 3.601,-3.6 -1.101,1.3 -2.301,2.501 -3.601,3.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path599",
    d: "m 30.52,172.561 c 0.622,0.898 1.551,1.489 2.16,2.4 -0.787,-0.733 -1.772,-1.269 -2.16,-2.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path601",
    d: "m 37.72,186.48 c 0.846,0.191 0.615,1.465 1.68,1.438 0.053,-0.271 0.269,-0.374 0.48,-0.479 -0.208,0.352 -0.359,0.762 -0.96,0.721 -0.388,-0.572 -0.862,-1.056 -1.2,-1.68 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path603",
    d: "m 29.56,176.16 c -0.558,-0.162 -0.643,-0.797 -1.2,-0.96 -1.02,-1.22 -2.14,-2.34 -3.358,-3.36 -0.163,-0.558 -0.797,-0.643 -0.96,-1.2 1.938,1.74 3.778,3.58 5.518,5.52 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path605",
    d: "m 379.24,171.601 c 0.699,-0.901 1.499,-1.701 2.399,-2.4 -0.698,0.9 -1.497,1.7 -2.399,2.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path607",
    d: "m 373.001,177.84 c 0.777,-0.98 1.657,-1.86 2.64,-2.64 -0.78,0.981 -1.66,1.861 -2.64,2.64 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path609",
    d: "m 371.801,174.24 c 1.501,-1.139 2.579,-2.701 4.08,-3.84 -1.262,1.46 -2.62,2.82 -4.08,4.08 0,-0.08 0,-0.16 0,-0.24 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path611",
    d: "m 29.56,195.121 c -1.262,-0.898 -2.098,-2.223 -3.358,-3.12 -0.798,-0.084 -1.041,-0.719 -1.44,-1.2 1.873,1.164 3.419,2.658 4.798,4.32 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path613",
    d: "m 9.4,178.561 c -0.735,-1.103 -1.9,-1.775 -2.64,-2.878 1.06,0.86 2.02,1.82 2.88,2.878 -0.08,0 -0.16,0 -0.24,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path615",
    d: "m 5.8,174.96 c 0.49,0.07 0.471,0.649 0.96,0.72 0.737,1.103 1.902,1.777 2.64,2.88 -1.3,-1.1 -2.5,-2.299 -3.6,-3.6 z"
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "path617",
    d: "m 9.64,178.561 c 1.654,2.472 7.26,4.459 10.32,1.92 -0.036,2.446 -2.761,4.278 -6,4.32 3.687,1.913 7.537,3.663 10.8,6 0.399,0.481 0.644,1.116 1.44,1.2 1.02,1.22 2.14,2.34 3.358,3.36 1.358,2 2.736,3.982 4.08,6 -1.427,-0.176 -3.522,-1.754 -5.76,-1.92 C 24.732,193.148 19.192,189.249 13,186 c 0.471,1.837 2.162,4.879 0.96,7.92 -1.669,-3.171 -4.995,-5.477 -6.48,-9.6 -1.65,-4.59 -2.571,-9.004 -6.96,-10.8 1.892,-1.279 3.864,0.731 5.28,1.44 1.1,1.3 2.3,2.5 3.6,3.601 0.08,0 0.16,0 0.24,0 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path619",
    d: "m 26.2,192 c 1.262,0.898 2.098,2.223 3.358,3.12 0,0.08 0,0.16 0,0.239 C 28.34,194.341 27.22,193.221 26.2,192 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path621",
    d: "m 379.001,195.121 c 1.1,-1.301 2.3,-2.5 3.6,-3.6 -0.045,0.192 -0.24,0.237 -0.24,0.479 -1.06,0.857 -2.02,1.818 -2.88,2.88 -0.197,0.046 -0.241,0.241 -0.48,0.241 z"
  }), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "path623",
    d: "m 398.921,174.48 c 1.396,-0.469 2.694,-1.958 4.56,-1.2 -4.641,2.141 -5.313,7.86 -7.68,12.72 -1.597,3.275 -4.179,4.93 -5.521,7.92 -1.192,-2.682 -0.051,-5.984 0.96,-7.92 -3.346,1.375 -5.952,3.488 -8.641,5.52 -1.3,1.102 -2.5,2.301 -3.602,3.602 -0.947,1.37 -2.147,2.49 -2.641,4.318 -2.207,0.514 -4.488,0.953 -5.76,2.4 3.366,-7.754 10.834,-13.486 19.438,-16.8 -2.798,-0.722 -5.579,-1.46 -6,-4.56 2.905,2.351 8.234,0.776 10.08,-1.44 1.301,-1.101 2.5,-2.3 3.602,-3.6 0.709,-0.016 0.896,-0.548 1.205,-0.96 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path625",
    d: "m 394.119,179.041 c 0.045,-0.195 0.24,-0.239 0.239,-0.48 1.263,-0.896 2.101,-2.222 3.36,-3.12 -1.099,1.3 -2.297,2.498 -3.599,3.6 z"
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "path627",
    d: "m 50.44,188.641 c -0.314,1.533 -1.906,1.104 -2.88,1.44 -3.609,1.255 -6.703,3.583 -9.358,5.76 0.729,-2.562 8.315,-10.136 12.238,-7.2 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path629",
    d: "m 361.961,190.8 c 1.061,0.86 2.021,1.82 2.88,2.88 -1.061,-0.86 -2.021,-1.819 -2.88,-2.88 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path631",
    d: "m 163.96,284.4 c 0.979,0.777 1.858,1.66 2.64,2.641 -0.98,-0.78 -1.86,-1.66 -2.64,-2.641 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path633",
    d: "m 167.081,287.521 c 1.262,0.896 2.098,2.222 3.358,3.119 1.056,0.627 1.933,1.43 2.642,2.399 -2.129,-1.71 -4.293,-3.387 -6,-5.518 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path635",
    d: "m 237.16,281.761 c 1.5,-1.7 3.101,-3.3 4.801,-4.8 -1.5,1.7 -3.101,3.3 -4.801,4.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path637",
    d: "m 162.28,277.2 c 1.462,1.26 2.82,2.62 4.08,4.08 -0.342,-0.058 -0.403,-0.396 -0.72,-0.479 -0.78,-0.98 -1.66,-1.859 -2.64,-2.641 -0.07,-0.489 -0.649,-0.471 -0.72,-0.96 z"
  }), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "path639",
    d: "m 242.921,276.24 c 10.976,-12.146 19.563,-26.678 22.8,-46.562 -0.067,-0.429 0.227,-0.491 0.24,-0.239 -3.022,23.219 -12.9,39.58 -24.96,53.761 -1.063,0.86 -2.021,1.819 -2.881,2.88 -0.86,1.061 -1.819,2.021 -2.88,2.881 -1.142,0.939 -2.182,1.979 -3.12,3.12 -9.021,7.54 -18.667,14.452 -30,19.68 -5.265,-2.258 -9.858,-5.183 -14.642,-7.92 -0.681,-0.839 -1.796,-1.243 -2.64,-1.92 -4.2,-2.68 -7.826,-5.935 -11.76,-8.88 -0.709,-0.971 -1.586,-1.773 -2.642,-2.4 -2.06,-2.26 -4.22,-4.42 -6.479,-6.479 -12.333,-14.229 -22.531,-30.59 -25.682,-54 3.808,19.874 12.26,35.102 24,47.04 0.071,0.487 0.649,0.471 0.722,0.96 0.777,0.979 1.66,1.859 2.64,2.641 0.315,0.085 0.377,0.424 0.72,0.479 0.78,0.979 1.66,1.858 2.642,2.641 1.999,1.603 3.756,3.444 6,4.8 0.586,0.854 1.584,1.297 2.398,1.922 5.399,3.934 11.15,7.532 18,10.799 1.846,0.881 4.726,2.834 6.48,2.881 2.172,0.059 5.86,-2.444 8.16,-3.602 7.858,-3.951 15.112,-8.437 21.358,-13.68 0.891,-0.792 1.995,-1.365 2.642,-2.398 1.175,-0.268 1.424,-1.457 2.398,-1.922 2.265,-2.063 4.425,-4.222 6.486,-6.483 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path641",
    d: "m 163,278.16 c 0.979,0.779 1.858,1.66 2.64,2.641 -0.98,-0.78 -1.86,-1.66 -2.64,-2.641 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path643",
    d: "m 166.36,281.28 c 0.98,0.78 1.86,1.659 2.642,2.641 -0.982,-0.78 -1.862,-1.66 -2.642,-2.641 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path645",
    d: "m 175,288.721 c 0.814,0.624 1.813,1.066 2.398,1.92 -0.814,-0.623 -1.811,-1.067 -2.398,-1.92 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path647",
    d: "m 231.4,287.041 c 0.664,-1.018 1.79,-1.571 2.642,-2.4 -0.646,1.035 -1.753,1.608 -2.642,2.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path649",
    d: "m 236.44,282.721 c 0.07,-0.488 0.649,-0.471 0.722,-0.96 1.698,-1.5 3.301,-3.1 4.801,-4.8 0.489,-0.07 0.47,-0.648 0.96,-0.721 -2.063,2.261 -4.223,4.42 -6.483,6.481 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path651",
    d: "m 238.12,286.08 c 0.858,-1.061 1.818,-2.02 2.881,-2.88 -0.86,1.061 -1.82,2.021 -2.881,2.88 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path653",
    d: "m 232.12,292.081 c 0.938,-1.142 1.979,-2.181 3.118,-3.12 -0.937,1.141 -1.977,2.18 -3.118,3.12 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path655",
    d: "m 187.48,303.841 c -0.936,-0.584 -2.021,-1.02 -2.64,-1.92 0.844,0.677 1.959,1.081 2.64,1.92 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path657",
    d: "m 170.44,290.641 c -1.262,-0.896 -2.098,-2.222 -3.358,-3.119 -0.106,-0.215 -0.211,-0.43 -0.48,-0.479 -0.78,-0.979 -1.66,-1.859 -2.64,-2.643 0,-0.078 0,-0.158 0,-0.238 2.258,2.059 4.418,4.219 6.478,6.479 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path663",
    d: "m 99.4,300.001 c 0.649,-0.871 1.968,-1.074 2.88,-1.681 -0.649,0.871 -1.966,1.075 -2.88,1.681 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path667",
    d: "m 366.761,324.48 c 1.011,-0.989 2.051,-1.949 3.12,-2.881 -0.893,1.109 -1.868,2.133 -3.12,2.881 z"
  }), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "path669",
    d: "m 369.881,321.602 c 1.665,-2.336 2.997,-5.004 3.358,-8.641 -0.183,10.673 -5.113,17.184 -18,16.319 -8.734,-0.585 -16.979,-4.244 -24.479,-7.681 -21.115,-9.674 -41.182,-25.4 -68.16,-27.841 1.553,3.325 4.917,6.089 2.642,11.28 -1.1,2.504 -6.847,6.979 -9.602,6.479 -1.179,-0.215 -2.366,-2.619 -3.36,-3.601 -1.826,-1.806 -4.699,-3.591 -7.68,-5.521 -2.021,-1.312 -7.092,-3.744 -7.2,-6 -0.148,-3.153 5.479,-4.144 8.4,-4.802 3.89,-0.875 7.574,-1.255 11.28,-1.68 1.277,0 2.56,0 3.84,0 28.246,2.974 48.553,19.063 71.52,29.521 8.666,3.944 23.99,11.096 34.32,5.041 1.253,-0.743 2.228,-1.767 3.121,-2.873 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path671",
    d: "m 318.039,306.721 c -0.865,-0.545 -2.533,-1.984 -0.96,-2.88 -1.174,1.24 0.39,2.016 0.96,2.88 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path673",
    d: "m 75.16,297.602 c 0.898,0.698 1.699,1.498 2.398,2.399 -0.898,-0.7 -1.698,-1.5 -2.398,-2.399 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path675",
    d: "m 54.04,305.041 c 0.912,0.768 1.868,1.492 2.398,2.641 -0.777,-0.903 -1.657,-1.702 -2.398,-2.641 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path677",
    d: "m 53.8,319.2 c 0.74,-0.939 1.621,-1.738 2.4,-2.64 -0.532,1.148 -1.488,1.874 -2.4,2.64 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    id: "path679",
    d: "m 47.08,319.2 c -0.677,-4.685 -1.713,-9.007 -2.16,-13.92 11.155,-2.371 12.315,14.26 2.16,13.92 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path699",
    d: "m 147.16,344.4 c -1.86,-0.859 -2.742,-2.698 -3.842,-4.319 1.313,1.329 2.269,3.013 3.842,4.08 0,0.079 0,0.159 0,0.239 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path701",
    d: "m 262.36,341.041 c -0.824,1.732 -2.104,3.014 -3.84,3.84 1.199,-1.279 2.734,-2.227 3.602,-3.84 0.078,0 0.158,0 0.238,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path703",
    d: "m 141.16,335.279 c -0.326,-0.553 -0.69,-1.068 -0.722,-1.92 0.492,0.39 0.605,1.156 0.96,1.682 -0.202,-0.045 -0.224,0.094 -0.238,0.238 z"
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "path759",
    d: "m 55,506.161 c 6.982,-0.536 12.38,-2.66 17.04,-5.521 -1.293,4.147 -3.625,9.336 -5.521,13.683 -10.8,0 -21.6,0 -32.398,0 0.829,-3.331 1.817,-6.501 1.68,-10.8 0.4,-9.44 0.4,-20.563 0,-30.001 0.15,-4.393 -0.849,-7.633 -1.68,-11.04 -0.004,-0.121 -0.051,-0.315 -0.24,-0.239 3.187,-1.271 10.451,0.261 14.16,0 -0.858,2.502 -1.582,5.138 -1.682,8.397 -0.554,0.729 -0.085,2.478 -0.238,3.603 -0.4,10.16 -0.4,22 0,32.16 2.88,-0.161 6.398,0.317 8.879,-0.242 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    id: "path773",
    d: "m 214.36,483.121 c 0.562,-3.921 0.08,-8.88 0.24,-13.2 2.642,0 5.28,0 7.92,0 9.342,1.538 14.53,7.229 15.36,17.28 0,1.28 0,2.56 0,3.84 -0.162,10.718 -6.228,15.535 -17.04,15.6 -2.08,0 -4.16,0 -6.24,0 -0.158,-2.159 0.318,-4.958 -0.24,-6.72 0,-5.6 0,-11.2 0,-16.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    id: "path777",
    d: "m 116.44,501.601 c -0.899,0.7 -1.701,1.5 -2.398,2.4 -10.594,8.327 -26.608,-1.598 -25.682,-15.36 0,-1.117 0,-2.237 0,-3.357 -0.86,-13.063 15.141,-19.555 24.722,-12 0.698,0.898 1.5,1.7 2.398,2.397 2.204,2.916 4.063,6.181 4.32,11.04 0,2.16 0,4.32 0,6.48 -0.264,3.655 -1.691,6.149 -3.36,8.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    id: "path779",
    d: "m 302.44,486.481 c 0,2.317 0,4.64 0,6.96 -0.288,3.551 -1.729,5.949 -3.359,8.157 -0.899,0.7 -1.699,1.5 -2.398,2.4 -4.623,4.602 -14.696,3.19 -18.96,-0.24 -10.354,-8.331 -9.574,-33.416 7.92,-33.84 9.985,-0.239 15.695,7.533 16.797,16.563 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path785",
    d: "m 127.48,80.64 c 1.12,0 2.24,0 3.36,0 -0.399,0.479 -4.501,0.286 -3.36,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path787",
    d: "m 54.04,96.96 c 0.558,1.443 0.082,3.918 0.238,5.76 -0.555,-1.442 -0.08,-3.918 -0.238,-5.76 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path789",
    d: "m 349.961,99.84 c -0.156,1.284 0.313,3.195 -0.24,4.08 0.156,-1.283 -0.316,-3.195 0.24,-4.08 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path791",
    d: "m 387.881,100.56 c 0,2 0,4 0,6 -0.4,-1.444 -0.4,-4.556 0,-6 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path793",
    d: "m 391.24,103.68 c 0.557,0.885 0.083,2.796 0.239,4.08 -0.553,-0.885 -0.082,-2.796 -0.239,-4.08 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path797",
    d: "m 94.12,110.4 c 0.528,-0.358 2.938,-0.547 3.12,0.24 -0.773,-0.346 -2.013,-0.226 -3.12,-0.24 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path801",
    d: "m 193,152.16 c 1.35,0.301 3.714,0.423 5.04,0 -0.665,0.743 -4.389,0.826 -5.04,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path803",
    d: "m 144.041,206.161 c 0.049,1.969 0.004,3.844 -0.24,5.521 -0.08,0 -0.16,0 -0.24,0 0.16,-1.761 0.335,-3.505 0.24,-5.521 0.079,0 0.159,0 0.24,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    id: "path805",
    d: "m 260.44,206.161 c 0,1.84 0,3.68 0,5.521 -0.557,-1.363 -0.082,-3.759 -0.238,-5.521 0.078,0 0.158,0 0.238,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path807",
    d: "m 17.56,210.96 c 0.015,1.106 -0.104,2.347 0.24,3.12 -0.787,-0.182 -0.598,-2.589 -0.24,-3.12 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d50100"
    },
    id: "path809",
    d: "m 260.44,211.682 c 0.613,3.945 2.053,7.069 4.32,9.359 0,0.08 0,0.16 0,0.24 0.787,0.092 1.058,0.701 1.68,0.96 0,0.72 0,1.44 0,2.159 -0.104,0.935 -0.182,1.897 -0.479,2.641 -17.688,0.004 -36.631,-0.005 -53.521,0 -0.436,16.02 -0.238,33.994 -0.238,51.6 0,5.236 0.37,13.334 -0.479,17.041 -3.022,0.478 -6.349,4.27 -9.6,4.319 -1.719,0.026 -3.81,-1.59 -5.521,-2.399 -1.897,-0.897 -3.718,-1.558 -5.28,-2.641 0,-22.64 0,-45.281 0,-67.92 -16.807,-0.164 -36.313,0.323 -53.52,-0.24 0.128,-0.928 -0.428,-1.171 -0.24,-2.16 0.023,-1.097 -0.194,-2.435 0.48,-2.88 3.231,-1.966 4.936,-5.464 5.52,-10.079 0.08,0 0.16,0 0.24,0 0.245,-1.677 0.289,-3.552 0.24,-5.521 15.6,-0.16 31.84,0.319 47.04,-0.24 0.72,-17.44 -0.24,-36.56 0.479,-54 0.213,0.186 0.542,0.258 0.96,0.24 0.16,0 0.32,0 0.48,0 0.649,0.826 4.375,0.743 5.04,0 1,-0.12 1.398,-0.839 2.398,-0.96 2.077,-1.123 4.146,-2.254 5.521,-4.08 1.51,0.891 2.854,1.947 5.521,1.68 0.58,-0.106 0.621,0.082 0.722,0.48 0.938,3.77 0,9.672 0,14.16 0,13.848 0,29 0,42.48 15.521,0.56 32.078,0.081 48,0.24 0.155,1.761 -0.319,4.157 0.237,5.521 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path811",
    d: "m 266.921,222.24 c 0.34,-0.021 0.68,-0.04 0.72,0.24 -0.32,0 -0.64,0 -0.96,0 -0.146,0.574 0.301,1.74 -0.24,1.92 0,-0.721 0,-1.44 0,-2.16 0.16,0 0.32,0 0.48,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path823",
    d: "m 210.761,376.561 c -0.16,10.48 0.319,21.603 -0.24,31.683 0.16,-10.483 -0.321,-21.603 0.24,-31.683 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    id: "path849",
    d: "m 307.48,284.4 c 1.64,-0.197 3.082,-0.02 4.08,0.479 3.297,1.646 5.087,9.139 0.96,12.24 -3.496,2.628 -9.854,0.333 -10.56,-4.563 -0.724,-5.009 1.792,-7.706 5.52,-8.156 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    id: "path851",
    d: "m 69.88,311.761 c -4.692,0.298 -9.094,-4.2 -7.2,-9.601 2.626,-7.485 16.266,-3.086 12.96,6.24 -0.711,2.008 -2.736,3.168 -5.76,3.361 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    id: "path855",
    d: "m 185.561,441.841 c 0,-1.04 0,-2.08 0,-3.12 0.186,-3.964 4.418,-6.369 8.4,-5.04 4.128,1.379 6.293,9.588 2.398,13.2 -3.744,3.474 -11.242,0.626 -10.798,-5.04 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path857",
    d: "m 217.48,44.4 c -0.157,1.443 0.316,3.516 -0.24,4.56 0,-1.52 0,-3.04 0,-4.56 0.08,0 0.16,0 0.24,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path859",
    d: "m 110.92,53.28 c 2,0 4,0 6,0 -1.443,0.4 -4.556,0.4 -6,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path865",
    d: "m 349.721,84.72 c 0.556,0.964 0.083,2.957 0.24,4.32 -0.556,-0.964 -0.083,-2.957 -0.24,-4.32 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path867",
    d: "m 54.28,85.92 c -0.156,1.922 0.317,4.478 -0.238,6 0.156,-1.921 -0.319,-4.478 0.238,-6 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path869",
    d: "m 146.92,95.04 c 3.28,0 6.56,0 9.84,0 -2.721,0.4 -7.118,0.4 -9.84,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path873",
    d: "m 391.48,95.76 c -0.156,1.284 0.315,3.195 -0.239,4.08 0.156,-1.283 -0.315,-3.195 0.239,-4.08 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path875",
    d: "m 12.76,97.68 c 0.399,2.162 0.399,5.998 0,8.16 0,-2.72 0,-5.44 0,-8.16 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path877",
    d: "m 133.72,100.32 c 1.523,-0.399 4.717,-0.399 6.24,0 -2.08,0 -4.16,0 -6.24,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path887",
    d: "m 25.48,117.6 c 0.559,1.283 0.083,3.598 0.24,5.28 -0.557,-1.283 -0.082,-3.598 -0.24,-5.28 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path889",
    d: "m 116.44,123.84 c 1.2,0 2.4,0 3.602,0 -0.651,0.399 -2.952,0.399 -3.602,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path893",
    d: "m 143.8,144.72 c 1.364,-0.399 4.396,-0.399 5.76,0 -1.92,0 -3.84,0 -5.76,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path897",
    d: "m 389.079,150.24 c -0.157,2.961 0.318,6.559 -0.238,9.12 0.157,-2.961 -0.32,-6.559 0.238,-9.12 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path905",
    d: "m 133.72,280.561 c 0.557,1.283 0.083,3.6 0.24,5.28 -0.557,-1.282 -0.082,-3.598 -0.24,-5.28 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path921",
    d: "m 170.92,377.281 c 0.398,10.72 0.398,23.119 0,33.84 0,-11.28 0,-22.56 0,-33.84 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path923",
    d: "m 180.76,378.001 c 0,10.88 0,21.761 0,32.64 -0.4,-10.321 -0.4,-22.321 0,-32.64 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path937",
    d: "m 142.84,471.121 c 0.398,10.88 0.398,23.438 0,34.32 0,-11.44 0,-22.88 0,-34.32 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path939",
    d: "m 185.8,471.121 c -0.16,10.32 0.32,21.28 -0.24,31.2 0.16,-10.32 -0.319,-21.28 0.24,-31.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path941",
    d: "m 360.039,472.081 c 0.399,8.4 0.399,18.479 0,26.88 -0.358,-0.359 -0.719,-0.722 -0.96,-1.2 0.489,0.071 0.473,0.649 0.96,0.723 0,-8.803 0,-17.603 0,-26.403 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path945",
    d: "m 369.641,472.561 c 0,10.883 0,21.763 0,32.643 -0.401,-10.323 -0.401,-22.323 0,-32.643 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path953",
    d: "m 349.961,89.04 c 0.397,3.042 0.397,7.759 0,10.8 0,-3.6 0,-7.2 0,-10.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path955",
    d: "m 185.561,111.12 c 0,1.28 0,2.56 0,3.84 -0.399,-0.728 -0.399,-3.111 0,-3.84 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path963",
    d: "m 220.12,375.602 c -0.159,10.642 0.318,21.92 -0.239,32.16 0.159,-10.641 -0.32,-21.921 0.239,-32.16 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path969",
    d: "m 326.921,473.041 c 0.397,9.601 0.397,20.88 0,30.48 0,-10.16 0,-20.32 0,-30.48 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path971",
    d: "m 35.8,473.521 c 0.4,9.438 0.4,20.561 0,30.001 0,-10.001 0,-20.001 0,-30.001 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8b8b"
    },
    id: "path973",
    d: "m 46.12,474.241 c 0,10.64 0,21.28 0,31.92 0,0.08 0,0.16 0,0.24 -0.4,-10.16 -0.4,-22 0,-32.16 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d4d1"
    },
    id: "path985",
    d: "m 131.08,222.96 c 0.673,0.287 1.654,0.265 2.64,0.24 -0.4,0.462 -2.213,0.307 -2.64,0 0,-0.079 0,-0.159 0,-0.24 z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityOfLondonLogo);
export default __webpack_public_path__ + "static/media/City_of_London_logo.a3bb74868488976eca2c81020d23e91a.svg";
export { ForwardRef as ReactComponent };